/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface Action {
  expression?: string;
}

export interface ActionDeferred {
  trigger?: DeferredTrigger;
}

/** The top-level container for all rules. */
export interface ActionsRules {
  settings?: ActionsRulesSettings[];
  specs?: ActionsRulesSpec[];
}

/** The notification to be sent when a rule's conditions are met. */
export interface ActionsRulesAction {
  /** Deferred configuration for scheduling the action to be executed later. */
  deferred?: ActionDeferred;
  email?: TrackingActionsEmailAdditionalConfiguration;
  /** ... */
  emarsys?: TrackingActionsEmarsysAdditionalConfiguration;
  enabled?: boolean;
  http?: TrackingActionsHttpAdditionalConfiguration;
  /** Id is a unique identifier for this action. */
  id?: string;
  noop?: TrackingActionsNoopAdditionalConfiguration;
  /** Reference in form of a URI act://local/settings_ref, to identify the global settings. */
  reference?: string;
  type?: TrackingActionsType;
}

export interface ActionsRulesSettings {
  email?: TrackingActionsEmailGlobalConfiguration;
  emarsys?: TrackingActionsEmarsysGlobalConfiguration;
  http?: TrackingActionsHttpGlobalConfiguration;
  noop?: TrackingActionsNoopGlobalConfiguration;
  /** reference is a unique identifier for this settings configuration */
  reference?: string;
  type?: TrackingActionsType;
}

/**
 * Spec defines when to trigger an action and what content to send.
 * It contains conditions that must be met (when clause) and the notification
 * configuration to use when those conditions are satisfied.
 */
export interface ActionsRulesSpec {
  /** Actions defines references to the actions and any additional configuration if needed. */
  actions?: ActionsRulesAction[];
  /** Description provides additional context about the rule's purpose */
  description?: string;
  /**
   * Enabled indicates whether this rule is active and should be evaluated.
   * If false, the rule will be ignored during notification processing.
   */
  enabled?: boolean;
  /** Name is a human-readable identifier for the rule */
  name?: string;
  /** Defines the condition scope and the conditions that must be met. */
  rule?: ActionsRulesSpecRule;
  /** Enum representing the target model. */
  target?: SpecTargetType;
}

export interface ActionsRulesSpecRule {
  conditions?: string[];
  type?: SpecRuleType;
}

/** @default "DEFAULT" */
export type AdditionalConfigurationContactMode = "DEFAULT" | "CUSTOM";

/** Controls how the system handles HTTP responses. */
export interface AdditionalConfigurationResponseHandling {
  /**
   * If logging body, cap the max bytes for safety.
   * @format int32
   */
  max_body_bytes?: number;
  strategy?: AdditionalConfigurationResponseHandlingStrategy;
}

/** @default "STRATEGY_UNSPECIFIED" */
export type AdditionalConfigurationResponseHandlingStrategy =
  | "STRATEGY_UNSPECIFIED"
  | "IGNORE"
  | "LOG_BODY"
  | "FAIL_ON_NON_2XX";

export interface AdditionalOptionsInstoreSearch {
  enabled?: boolean;
  /** @format int32 */
  locations_limit?: number;
}

export interface Addon {
  carrier?: string;
  code?: string;
  description?: string;
  /** Additional fields that can be passed to use the addon. */
  fields?: AddonFields[];
  /** Ingrid identifier of an addon. // Deprecated, use type. */
  name?: string;
  shipping_methods?: string[];
  /** Internal type of an addon. */
  type?: Type;
}

export interface AddonFields {
  name?: string;
  required?: boolean;
}

/** Common address entity that used almost everywhere in Ingrid's API. */
export interface Address {
  /** List of address lines part of address such as street and building number */
  address_lines?: string[];
  /** Number of the apartment. */
  apartment_number?: string;
  /**
   * Attention field. Can be used to indicate an employee if the address is a
   * company address [optional]
   */
  attn?: string;
  /** in the UK some buildings do not have a number, only a name */
  building_name?: string;
  /** Care of part of address usually written as `c/o` [optional] */
  care_of?: string;
  /** Name of the city */
  city?: string;
  /**
   * Geolocation coordinates of the address. If reverse geolocation lookup of the
   * address was successful this property will be populated. If coordinates are
   * available they will be used to in service point search. In case of
   * `search_address` coordinates can also be set by merchant if known.
   */
  coordinates?: Coordinates;
  /**
   * Country should be specified as two uppercase letters (ISO Alpha-2).
   * Example `SE` for Sweden, `ES` for Spain.
   */
  country?: string;
  /** The door code to the main entrance of the building if applicable [optional] */
  door_code?: string;
  /** Floor number [optional] */
  floor_number?: string;
  /** Customer or company name */
  name?: string;
  /** ID of the PO Box [optional] */
  po_box_id?: string;
  /** Postal code (or zipcode in US) */
  postal_code?: string;
  /** Region can be a state or a province [optional] */
  region?: string;
  /** Name of the street. */
  street?: string;
  /** Number of the street. */
  street_number?: string;
  /**
   * Further division of regions. Example countries are GB, IE, IT, LT, MX
   * For example for The Republic Of Ireland there are 4 provinces (regions),
   * e.g. `Connacht` and 26 counties (subregions), e.g. `Galway`
   * Format is ISO 3166 where applicable, exceptions are e.g. Mexico [optional]
   */
  subregion?: string;
}

/** @default "INGRID" */
export type AddressBookProvider = "INGRID" | "HM" | "HM_V2";

export interface AddressFormConfiguration {
  by_country?: Record<string, AddressFormConfigurationCountry>;
  features?: Record<string, AddressFormFeatures>;
  global_features?: Record<string, AddressFormGlobalFeatures>;
  layouts?: Record<string, AddressFormLayout>;
  validations?: Record<string, AddressFormValidation>;
}

export interface AddressFormConfigurationCountry {
  billing_features?: string;
  billing_layout?: string;
  billing_validation?: string;
  enabled?: boolean;
  features?: string;
  global_features?: string;
  layout?: string;
  validation?: string;
}

export interface AddressFormFeatures {
  address_book_provider?: AddressBookProvider;
  /** Autocomplete provider to "search" addresses that user starts typing as street. */
  autocomplete_provider?: AutocompleteProvider;
  frozen_fields_after_prefill?: FrozenFieldsAfterPrefill;
  /** Hides address book in UI, address provider is still used. */
  hide_address_book?: boolean;
  /**
   * Overwrites the locales send in the address validation request.
   * The address returned from Google depends on the locale sent in the request.
   * Example usage: the AF is in Korean, the address in latin characters
   * and we want Google to also return the address in latin characters.
   */
  overwrite_locales?: string[];
  show_billing_address?: boolean;
  /** Suggestion provider to validate address and suggest correction if invalid. */
  suggestion_provider?: AutocompleteProvider;
}

/** @default "UNDEFINED" */
export type AddressFormFieldName =
  | "UNDEFINED"
  | "ADDRESS_LINE"
  | "CITY"
  | "POSTAL_CODE"
  | "REGION"
  | "STREET"
  | "STREET_NUMBER"
  | "APARTMENT_NUMBER"
  | "NAME"
  | "FIRST_NAME"
  | "LAST_NAME"
  | "PHONE_NUMBER"
  | "EMAIL"
  | "VAT"
  | "COMPANY_NAME"
  | "CARE_OF"
  | "FLOOR"
  | "NATIONAL_IDENTIFICATION_NUMBER"
  | "SUBREGION"
  | "CUSTOMS_NUMBER"
  | "COUNTRY"
  | "ADDRESS_DETAILS";

/** @default "DEFAULT" */
export type AddressFormFieldType = "DEFAULT" | "SEARCHABLE" | "OPTIONAL_ADDRESS_LINE_STREET_NUMBER";

export interface AddressFormGlobalFeatures {
  /** Global features are applied to both recipient and billing address forms simultaneously. */
  enable_extended_validation?: boolean;
}

export interface AddressFormLayout {
  fields?: AddressFormLayoutField[];
}

export interface AddressFormLayoutField {
  name?: AddressFormFieldName;
  /** @format int64 */
  span?: number;
  type?: AddressFormFieldType;
}

export interface AddressFormValidation {
  length?: AddressFormValidationLength[];
  regex?: AddressFormValidationRegex[];
  required?: AddressFormValidationRequired[];
}

export interface AddressFormValidationLength {
  fields?: AddressFormFieldName[];
  /** @format int64 */
  max?: number;
  /** @format int64 */
  min?: number;
}

export interface AddressFormValidationRegex {
  /** Human readable description of the pattern. Used for error messages. */
  allowed_pattern?: string;
  allowed_pattern_description?: string;
  field?: AddressFormFieldName;
}

export interface AddressFormValidationRequired {
  fields?: AddressFormFieldName[];
  /** @format int64 */
  min?: number;
}

export interface AnalyticsSettings {
  /**
   * If set to true, regular activity events will not be sent to the analytics provider, even if statistical consent is enabled.
   * Survey-related events will still be sent if the survey feature is enabled.
   */
  disable_events_gathering?: BoolOptionV2;
}

export interface Any {
  "@type"?: string;
  [key: string]: any;
}

/** @default "DEFAULT_PROVIDER" */
export type AutocompleteProvider = "DEFAULT_PROVIDER" | "GOOGLE" | "GEPOSIT" | "LOQATE" | "NO_PROVIDER";

export interface Booking {
  enabled?: boolean;
  methods?: Record<string, BookingMethodConfiguration>;
}

export interface BookingMethodConfiguration {
  cron_cfg?: string;
  one_by_one?: boolean;
  strategy?: BookingStrategy;
}

/** @default "STRATEGY_UNKNOWN" */
export type BookingStrategy = "STRATEGY_UNKNOWN" | "STRATEGY_NOOP" | "STRATEGY_BATCHED";

/**
 * A boolean value
 * boolean value or an Expression. The client code must handle both cases.
 */
export type BoolOption = boolean;

export interface BoolOptionV2 {
  /** An expression that dynamically determines the value. */
  expression?: Expression;
  /** A boolean value */
  value?: boolean;
}

export interface CarrierProduct {
  /** CompositePriceRule contains group of PriceComponents, where each of them is evaluated and its value will be added to each other. */
  composite_price_rule?: CompositePriceRule;
  /** Deprecated: in favor of delivery_time in shipping_categories. [deprecated] */
  delivery_time?: DeliveryTime;
  delivery_types?: DeliveryType[];
  delivery_types_text?: string[];
  external_method_id?: string;
  /** Evaluated before fetch shipping options stage. */
  filter_rules?: FilterRule[];
  generate_default_shipping_options_on_error?: boolean;
  group_price_rules?: CheckoutGroupPriceRule[];
  operating_schedule?: OperatingScheduleCarrierItem;
  /** Evaluated after fetch shipping options stage. */
  post_filter_rules?: CarrierProductPostFilterRule[];
  price_rules?: PriceRule[];
  shipping_date_adjustment?: ShippingDateAdjustment;
  shipping_method?: string;
  supported_shipping_attributes?: string[];
}

export interface CarrierProductMapping {
  always_show_tracking_links?: boolean;
  /** carrier_product_id allows to map carrier_product_ref with internally defined carrier products */
  carrier_product_id?: string;
  carrier_product_ref?: string;
  /** Setting 'custom' to true implies that tracking URLs must be provided. */
  custom?: boolean;
  id?: string;
  /** Locale to tracking URL map. */
  tracking_links?: Record<string, string>;
}

export interface CarrierProductPostFilterRule {
  condition?: string;
}

/** CarrierProductSettings are used to configure product booked with Ingrid. */
export interface CarrierProductSettings {
  always_show_tracking_links?: boolean;
  carrier_product_id?: string;
  /** Setting 'custom' to true implies that tracking URLs must be provided. */
  custom?: boolean;
  /** Locale to tracking URL map. */
  tracking_links?: Record<string, string>;
}

export interface Category {
  /** Internal type of an addons. */
  addon_types?: Type[];
  /** Optional description shown in tooltips or help texts (e.g., "Covers shipments for loss or damage"). */
  description?: string;
  /** Human-friendly name of the category to display in UI (e.g., "Insurance"). */
  display_name?: string;
  /** Internal enum-based identifier of the category (e.g., CATEGORY_INSURANCE). */
  type?: CategoryType;
}

export interface CategoryCountrySettings {
  /** @format int32 */
  preselection_order?: number;
  use_for_fallback?: boolean;
}

export interface CategoryList {
  categories?: string[];
}

/**
 *  - CATEGORY_DELIVERY_CONFIRMATION: Addons that require the recipient or another person to sign for the delivery, providing proof of receipt.
 *  - CATEGORY_DELIVERY_HANDLING: Addons that affect how a shipment is physically handled or special installation/removal service.
 *  - CATEGORY_AGE_VERIFICATION: Addons related to verifying the age of the recipient before delivery. Often required for regulated items such as alcohol or tobacco.
 *  - CATEGORY_ID_VERIFICATION: Addons used to verify the identity of the recipient, including checks via ID cards or national identification systems like BankID.
 *  - CATEGORY_DELIVERY_NOTIFICATION: Addons that inform the sender or recipient about shipment events via SMS, email, phone, or physical notices.
 *  - CATEGORY_PICKUP: Addons related to picking up the shipment from a designated location such as a store, terminal, or parcel shop.
 *  - CATEGORY_RETURN: Addons involving return logistics, including return label generation or reverse logistics for swapped products.
 *  - CATEGORY_PAYMENT: Addons related to how the payment for delivery or items is processed, including cash-on-delivery, invoice-based options and postal indicia methods (e.g., franked postage).
 *  - CATEGORY_INSURANCE: Addons that provide coverage for loss or damage of the shipment, often with varying compensation limits.
 *  - CATEGORY_SUSTAINABILITY: Addons promoting environmentally friendly delivery options, such as carbon offset programs.
 *  - CATEGORY_DELIVERY_INSTRUCTION: Addons that specify physical actions or services to be performed by the courier at the delivery destination.
 *  - CATEGORY_DELIVERY_TIMING: Addons that specify preferred delivery timeframes or scheduling constraints.
 *  - CATEGORY_CUSTOMS: Addons related to customs declarations, billing, and item classification for cross-border shipments.
 *  - CATEGORY_MISC: Addons that do not clearly belong to other categories or are highly specialized/customized.
 *  - CATEGORY_TEMPERATURE_CONTROLLED: Addons that require temperature-controlled handling (cold/frozen/warm) during transport and storage; supports cold-chain compliance.
 *  - CATEGORY_CONTENT_GOODS: Addons determined by the nature of the shipped goods (pharmaceuticals, alcohol, nicotine, dangerous goods/LQ) and physical attributes (heavy, long etc.).
 * @default "CATEGORY_UNSPECIFIED"
 */
export type CategoryType =
  | "CATEGORY_UNSPECIFIED"
  | "CATEGORY_DELIVERY_CONFIRMATION"
  | "CATEGORY_DELIVERY_HANDLING"
  | "CATEGORY_AGE_VERIFICATION"
  | "CATEGORY_ID_VERIFICATION"
  | "CATEGORY_DELIVERY_NOTIFICATION"
  | "CATEGORY_PICKUP"
  | "CATEGORY_RETURN"
  | "CATEGORY_PAYMENT"
  | "CATEGORY_INSURANCE"
  | "CATEGORY_SUSTAINABILITY"
  | "CATEGORY_DELIVERY_INSTRUCTION"
  | "CATEGORY_DELIVERY_TIMING"
  | "CATEGORY_CUSTOMS"
  | "CATEGORY_MISC"
  | "CATEGORY_TEMPERATURE_CONTROLLED"
  | "CATEGORY_CONTENT_GOODS";

/** ChainStep represents a part of a chained delivery. */
export interface ChainStep {
  /**
   * - UNKNOWN: Delivery type is not known for some reason
   *  - DELIVERY: Home delivery
   *  - PICKUP: Delivery to a service point or a locker
   *  - MAILBOX: Delivery to customer's mailbox
   *  - INSTORE: Delivery to one of the merchants stores
   *  - INWAREHOUSE: Delivery to the warehouse. This type is used with chain delivery in warehouse-warehouse-delivery/pickup.
   */
  delivery_type?: DeliveryType;
  /** overwrite_shipping_method from which shipping methods are actually fetched. [optional] */
  overwrite_shipping_method?: string;
  /**
   * PredefinedShippingOption says that there is no need to call carrier. Instead this data should be used to create the
   * shipping option.
   */
  predefined_shipping_option?: PredefinedShippingOption;
  shipping_method?: string;
}

/** CheckoutGroupPriceRule is a type of price rule applied on group level after split. */
export interface CheckoutGroupPriceRule {
  /** @format int32 */
  price?: number;
  type?: CheckoutGroupPriceRuleType;
}

/**
 * Type is a type of price rule
 * @default "RULE_UNSPECIFIED"
 */
export type CheckoutGroupPriceRuleType =
  | "RULE_UNSPECIFIED"
  | "RULE_REDUCE_PRICE_WHEN_MORE_EXPENSIVE_PRODUCT_SELECTED"
  | "RULE_REDUCE_PRICE_HM";

/** CompositePriceRule contains group of PriceComponents, where each of them is evaluated and its value will be added to each other. */
export interface CompositePriceRule {
  price_components?: PriceComponent[];
}

export interface CondContainsAll {
  attrs?: string[];
}

export interface Condition {
  requirement?: string;
}

export interface ConditionalSortingRulesSet {
  conditions?: Condition[];
  sorting_rules?: SortingRule[];
}

/**
 * - ALL_CONFIG: ACTIVE and INACTIVE
 * @default "ALL_CONFIG"
 */
export type ConfigType = "ALL_CONFIG" | "ONLY_ACTIVE";

export interface ContactData {
  email?: string;
  phone?: string;
}

export interface ContentChannelConfig {
  embedded_widget?: ContentChannelConfigEmbeddedWidget;
}

export interface ContentChannelConfigEmbeddedWidget {
  hide_ingrid_logo?: boolean;
}

/** Geolocation coordinates */
export interface Coordinates {
  /**
   * Latitude
   * @format double
   */
  lat?: number;
  /**
   * Longitude
   * @format double
   */
  lng?: number;
}

export interface CountryTaxSettings {
  /** @format float */
  tax_rate?: number;
  tax_rate_per_region?: Record<string, number>;
}

export interface CreateMerchantRequest {
  merchant?: Merchant;
}

export interface CreateMerchantResponse {
  merchant?: Merchant;
}

export interface CreateSiteRequest {
  merchant_id?: string;
  site?: Site;
}

export interface CreateSiteResponse {
  site?: Site;
}

export interface CustomBookShippingMethod {
  shipping_method?: string;
}

export interface CustomBookingMethod {
  addresses?: CustomBookingMethodAddresses;
  booking_method?: string;
  /** Carrier full name. */
  carrier?: string;
  method?: string;
  /** Name of the shipping product. */
  name?: string;
  return_booking?: CustomBookingMethodReturnBooking;
  steps?: CustomBookingMethodStep[];
}

export interface CustomBookingMethodAddresses {
  /** Common address entity that used almost everywhere in Ingrid's API. */
  return?: Address;
}

export interface CustomBookingMethodReturnBooking {
  label_consolidation?: boolean;
  method?: string;
  use_address_from_as_return?: boolean;
}

export interface CustomBookingMethodStep {
  actions?: StepExpression[];
  filters?: StepExpression[];
  name?: string;
}

export interface CustomEventType {
  custom_event_type_id?: string;
  localization?: Record<string, CustomEventTypeLocalization>;
  name?: string;
  state?: State;
}

export interface CustomEventTypeLocalization {
  description?: string;
  name?: string;
}

export interface CustomFetchShippingOption {
  /**
   * - UNKNOWN: Delivery type is not known for some reason
   *  - DELIVERY: Home delivery
   *  - PICKUP: Delivery to a service point or a locker
   *  - MAILBOX: Delivery to customer's mailbox
   *  - INSTORE: Delivery to one of the merchants stores
   *  - INWAREHOUSE: Delivery to the warehouse. This type is used with chain delivery in warehouse-warehouse-delivery/pickup.
   */
  delivery_type?: DeliveryType;
  /**
   * DeliveryTypes which are supported by this method. When asked for an unsupported delivery type, no shipping options
   * are returned.
   */
  delivery_types?: DeliveryType[];
  pickup_location_types?: PickupLocationType[];
  /** ShippingMethod to call. */
  shipping_method?: string;
}

export interface CustomShippingMethod {
  book?: CustomBookShippingMethod;
  carrier_name?: string;
  /**
   * - UNKNOWN: Delivery type is not known for some reason
   *  - DELIVERY: Home delivery
   *  - PICKUP: Delivery to a service point or a locker
   *  - MAILBOX: Delivery to customer's mailbox
   *  - INSTORE: Delivery to one of the merchants stores
   *  - INWAREHOUSE: Delivery to the warehouse. This type is used with chain delivery in warehouse-warehouse-delivery/pickup.
   */
  delivery_type?: DeliveryType;
  /** Fetch specify parameters of real shipping option to be called. [optional] */
  fetch?: CustomFetchShippingOption;
  meta?: Record<string, string>;
  /** Name of the shipping product. */
  product?: string;
  shipping_method?: string;
  /** TimeSlots defines custom timeslots using expression engine. [optional] */
  time_slots?: CustomTimeSlot[];
}

export interface CustomShippingMethods {
  methods?: CustomShippingMethod[];
}

/**
 * CustomTimeSlot contains expressions for calculating each field in time slot.
 * Valid expressions include:
 * - pickup_time.start.add_days(1)
 * - pickup_time.start.add_business_days(1, address_from.country)
 */
export interface CustomTimeSlot {
  end?: string;
  /** [optional] */
  expires?: string;
  /**
   * FilterRules specify, when this time slot is visible. Sample filter_rule is:
   * region.id in ['region-se','region-no']
   */
  filter_rules?: FilterRule[];
  name?: string;
  start?: string;
}

/**
 *  - MODE_DEFAULT: With MODE_DEFAULT, we try to create basic contact by email address in the Emarsys system.
 * In case of conflict, we re-use already existing contact.
 *  - MODE_CUSTOM_CONTACT_CREATION: With MODE_CUSTOM_CONTACT, we try to create contact based on custom rules.
 * If more configuration is ever required, that would be separate settings.
 * @default "MODE_DEFAULT"
 */
export type CustomerEngagementPlatformMode = "MODE_DEFAULT" | "MODE_CUSTOM_CONTACT_CREATION";

export interface CutoffsItem {
  cutoff_times?: string[];
  day?: Day;
}

export interface DataRetentionConfiguration {
  /** applies to all services/software components dealing with sessions. */
  session_configuration?: SessionRetentionConfiguration;
}

/** @default "UNKNOWN_DAY" */
export type Day = "UNKNOWN_DAY" | "MON" | "TUE" | "WED" | "THU" | "FRI" | "SAT" | "SUN";

export interface DeferredTimeRule {
  condition?: string;
  type?: SpecRuleType;
}

export interface DeferredTrigger {
  time_rule?: DeferredTimeRule;
}

export interface DeliveryAddon {
  /** when type=TYPE_CARRIER specify addon details */
  carrier_addon?: DeliveryAddonCarrierAddon;
  defaults?: DeliveryAddonDefaults;
  external_id?: string;
  id?: string;
  localization?: Record<string, DeliveryAddonLocalization>;
  name?: string;
  price?: DeliveryAddonPrice;
  state?: State;
  /**
   *  - TYPE_CARRIER_DEFAULT: Default addons returned in FetchShippingOptions under default_addons field.
   * Default addons are not presented to end customer in UI (all other delivery addons are presented).
   *  - TYPE_ID_CHECK: Basic identity check – courier verifies recipient’s ID at delivery.
   *  - TYPE_WITHOUT_ID_CHECK: Basic identity check – courier will not verify recipient’s ID at delivery.
   *  - TYPE_DIGITAL_CHECK: Digital identity verification using BankID or similar.
   *  - TYPE_ID_MATCH_RECIPIENT: ID must match the name of the recipient (e.g. delivery only to person on label).
   *  - TYPE_AGE_CHECK: Basic age verification – courier confirms recipient meets age requirement (typically 18+).
   *  - TYPE_EXTENDED_AGE_CHECK: Extended age verification – includes more than one: signature, ID check or digital validation.
   *  - TYPE_AGE_CHECK_16: Age check requiring the recipient to be at least 16 years old.
   *  - TYPE_EXTENDED_AGE_CHECK_16: Extended age check for 16+ –  includes more than one: signature, ID check or digital validation.
   *  - TYPE_AGE_CHECK_18: Age check requiring the recipient to be at least 18 years old.
   *  - TYPE_EXTENDED_AGE_CHECK_18: Extended age check for 18+ – includes more than one: signature, ID check or digital validation.
   *  - TYPE_AGE_CHECK_20: Age check requiring the recipient to be at least 20 years old.
   *  - TYPE_AGE_CHECK_21: Age check requiring the recipient to be at least 21 years old.
   *  - TYPE_EMAIL: Notify recipient via email when shipment status is updated.
   *  - TYPE_SMS: Notify recipient via SMS when shipment status is updated.
   *  - TYPE_LETTER: Notify recipient via physical letter (paper notice, e.g., undeliverable or missed delivery).
   *  - TYPE_CALL: Notify recipient via phone call (automated or manual).
   *  - TYPE_NOTIFICATION: General or fallback notification without specifying the communication channel.
   *  - TYPE_PRE_EMAIL: Notify recipient via email before the shipment is dispatched or delivered (pre-alert).
   *  - TYPE_PRE_SMS: Notify recipient via SMS before the shipment is dispatched or delivered (pre-alert).
   *  - TYPE_PRE_CALL: Notify recipient via phone call before the shipment is dispatched or delivered.
   *  - TYPE_PRE_NOTIFICATION: General pre-notification without specifying channel (can be email, SMS, or call).
   *  - TYPE_WITHOUT_PRE_NOTIFICATION: Shipment proceeds without any pre-notification.
   *  - TYPE_LEAVE_AT_DOOR: Leave the parcel at the recipient’s door or in a designated safe place without requiring interaction.
   *  - TYPE_CARRY_IN: Courier is required to carry the parcel inside the recipient's home or building.
   *  - TYPE_CARRY_OUT: Courier is required to carry the parcel outside the recipient's home or building.
   *  - TYPE_HOME_DELIVERY: Deliver the parcel directly to the recipient’s home address instead of a pickup location or access point.
   *  - TYPE_ENDORSEMENT_ABANDON: Abandon the shipment if it cannot be delivered (no return or retry attempt).
   *  - TYPE_PERSONAL_DELIVERY: Deliver the parcel directly into the hands of the recipient; no drop-off allowed.
   *  - TYPE_INSTALLATION: Perform installation of the delivered item at the recipient's location (e.g., appliances or furniture).
   *  - TYPE_REMOVAL: Remove old items (e.g., used furniture or appliances) from the recipient’s location as part of the delivery service.
   *  - TYPE_RECYCLE: Collect old or used items from the recipient for recycling during the delivery process.
   *  - TYPE_SWAP: Collect old or used items from the recipient during the delivery process and swap with the delivery.
   *  - TYPE_DISABLE_MODIFICATIONS: Prevents the recipient from modifying delivery options, such as changing delivery location, time, or leave-at-door settings.
   *  - TYPE_OPTIONAL_SERVICE_POINT: Allows the recipient to change the pickup location or service point before delivery.
   *  - TYPE_FLEX_CHANGE: Allows the recipient to flexibly change the delivery method, time, or location while the shipment is in transit.
   *  - TYPE_UNWRAPPING: Perform unwrapping on delivered item at recipient's location.
   *  - TYPE_PICKUP_POINT_DELIVERY: Deliver the parcel directly to the pickup location or access point.
   *  - TYPE_MAILBOX_DELIVERY: Deliver the parcel directly to the mailbox directly.
   *  - TYPE_DELIVERY_BEFORE_8: Deliver the parcel before 8:00 AM on the scheduled delivery day.
   *  - TYPE_DELIVERY_BEFORE_9: Deliver the parcel before 9:00 AM on the scheduled delivery day.
   *  - TYPE_DELIVERY_BEFORE_10: Deliver the parcel before 10:00 AM on the scheduled delivery day.
   *  - TYPE_DELIVERY_BEFORE_12: Deliver the parcel before 12:00 PM (noon) on the scheduled delivery day.
   *  - TYPE_EVENING_DELIVERY: Deliver the parcel during the evening hours, typically after 5:00 PM.
   *  - TYPE_EXPRESS_DELIVERY: Prioritize the shipment for the fastest possible delivery, typically within 1–2 days depending on the carrier.
   *  - TYPE_PRIORITY_DELIVERY: Prioritize internal processing of the shipment to improve transit performance (carrier-defined).
   *  - TYPE_SATURDAY_DELIVERY: Deliver the parcel on a Saturday, even if it is outside standard weekday schedules.
   *  - TYPE_SUNDAY_DELIVERY: Deliver the parcel on a Sunday, if available within the carrier’s service area.
   *  - TYPE_SAME_DAY_DELIVERY: Deliver the parcel on the same day it is shipped, usually within a few hours.
   *  - TYPE_TIME_AGREED_DELIVERY: Delivery at a specific time window agreed between the sender and the carrier.
   *  - TYPE_BY_TRUCK: Shipment must be delivered using a truck, typically due to size, weight, or palletized load.
   *  - TYPE_PALLET_TRANSFER: EUR-pallet must be exchanged at the time of delivery.
   *  - TYPE_FRANKED_POSTAGE: Pre-paid postage method where the sender uses a franking machine or online portal to apply postage instead of stamps.
   *  - TYPE_CONTAINER_RENT: Temporary rental of a container or shipping unit required for the transport. Typically used for pallet shipments.
   *  - TYPE_LOADING_ASSISTANCE: Shipment requires mechanical or manual assistance to be loaded onto the vehicle at the pickup location.
   *  - TYPE_UNLOADING_ASSISTANCE: Shipment requires mechanical or manual assistance to be unloaded from the vehicle at the delivery location.
   *  - TYPE_THERMO_COLD: Shipment requires cold temperature handling (e.g., 2–8°C).
   *  - TYPE_THERMO_FROZEN: Shipment must be kept frozen throughout transport. (e.g., below 0°C)
   *  - TYPE_THERMO_WARM: Shipment must be kept warm or above a certain minimum temperature (e.g., 8–25°C).
   *  - TYPE_LONG_GOODS: Item is long or oversized, requiring special handling or space.
   *  - TYPE_PHARMACEUTICALS: Shipment contains pharmaceuticals and may require regulated handling.
   *  - TYPE_DANGEROUS_GOODS: Shipment contains hazardous materials and must comply with safety regulations.
   *  - TYPE_DANGEROUS_GOODS_LQ: Shipment contains a limited quantity of dangerous goods, exempt from full ADR handling.
   *  - TYPE_NON_STACKABLE: Parcel cannot be stacked during transport.
   *  - TYPE_POSTABLE: Parcel can fit directly into a mailbox.
   *  - TYPE_HANGING_GARMENT: Shipment contains garments that must remain hanging during transit.
   *  - TYPE_FRAGILE: Parcel is fragile and must be handled with extra care.
   *  - TYPE_ALCOHOL: Shipment contains alcohol and may require age verification or special handling.
   *  - TYPE_TYRES: Shipment contains tires, often bulky and requiring dedicated space or securing.
   *  - TYPE_NICOTINE: Shipment contains nicotine products and may require legal handling procedures.
   *  - TYPE_HEAVY: Indicates that the shipment is heavy and may require special handling or lifting equipment.
   *  - TYPE_COD: The recipient pays for the goods or shipping upon delivery (cash, card, or local method).
   *  - TYPE_SHIPPING_DISCOUNT: Applies a negotiated discount or subsidy to the shipping cost (usually requires prior agreement).
   *  - TYPE_RECIPIENT_PAYS: The recipient is responsible for covering the shipping cost, typically via invoice or contract with the carrier.
   *  - TYPE_KIND_QUANTITY: Specifies the type and quantity of items in the shipment (e.g., 3 boxes, 2 bottles); often required for customs or tariff purposes.
   *  - TYPE_CREDIT_WITH_INVOICE_DOCUMENTATION: Enables shipment to be billed after delivery via invoice, with official invoice documentation provided.
   *  - TYPE_CREDIT_WITHOUT_INVOICE_DOCUMENTATION: Enables post-delivery billing on credit without requiring formal invoice documentation.
   *  - TYPE_INSURANCE: Provides coverage for loss or damage of the shipment, based on declared value or carrier-specific terms.
   *  - TYPE_TERMINAL_PICKUP: The shipment will not be delivered to the recipient's address but must be picked up from a designated terminal or depot.
   *  - TYPE_PERSONAL_PICKUP: Shipment must be collected in person by the recipient, typically with ID verification, from a post office, store, or pickup point.
   *  - TYPE_RETENTION_EXTENDED: Extends the retention period for the shipment at the pickup location, typically from 7 to 14 days.
   *  - TYPE_RETURN_TO_SENDER: Instructs the carrier to return the shipment to the sender if it cannot be delivered to the recipient.
   *  - TYPE_RETURN_QR_CODE: Allows the recipient to return the shipment using a scannable QR code instead of / along with printed return label.
   *  - TYPE_PRINT_RETURN_LABEL: Enables printing of the return label at a pickup location or drop-off point, instead of requiring the sender to print it in advance.
   *  - TYPE_CLIMATE_COMPENSATION: Offsets the carbon emissions of the shipment by contributing to certified environmental initiatives.
   *  - TYPE_SHIPMENT_CONSOLIDATION: Indicates that multiple shipments are merged into one consolidated delivery, typically for logistical or operational efficiency.
   *  - TYPE_SHIPMENT_MULTI_PARCELS: Indicates that the shipment consists of multiple parcels under a single tracking number or delivery order.
   *  - TYPE_HIDE_CUSTOMER_PHONE: Hides the recipient's phone number from the carrier label or transmission for privacy or regulatory reasons.
   *  - TYPE_HIDE_CUSTOMER_EMAIL: Hides the recipient's email address from the carrier label or transmission for privacy or regulatory reasons.
   *  - TYPE_CUSTOMER_NAME_AS_CARRIER_INSTRUCTIONS: Passes the customer's name as part of delivery instructions, often used to override carrier restrictions or labels.
   *  - TYPE_RESIDENTIAL_ADDRESS_INDICATOR: Marks the delivery address as a residential location, which may affect handling or surcharges.
   *  - TYPE_SPLIT_SHIPMENT: Splits the shipment into multiple parcels or deliveries, typically due to size, weight, or inventory constraints.
   *  - TYPE_HIDE_CUSTOMER_DETAILS: Hides the customer details from the carrier label or transmission for privacy or regulatory reasons.
   *  - TYPE_SIGNATURE: Requires the recipient (or someone at the address) to sign for the shipment upon delivery.
   *  - TYPE_ADULT_SIGNATURE: Requires a legally recognized adult to sign for the shipment, often used for age-restricted deliveries.
   *  - TYPE_INDIRECT_SIGNATURE: Allows someone other than the primary recipient (e.g., neighbor or receptionist) to sign for the shipment.
   *  - TYPE_WITHOUT_POD: The carrier will deliver the package without collecting a signature or proof of delivery.
   *  - TYPE_SIGNATURE_PHOTO_POD: Captures a photo as proof of delivery, often showing the parcel at the drop-off location.
   *  - TYPE_EXTENDED_SIGNATURE_POD: Includes multiple proof of deliveries, such as a high-resolution image, signature, timestamp, and geolocation.
   */
  type?: Type;
}

export interface DeliveryAddonCarrierAddon {
  /** Carrier name for dynamic addon, ex "age_check" for DHL */
  name?: string;
  /**
   * Leave empty to be used for all shipping methods
   * This is useful for categories with multiple shipping methods
   */
  shipping_methods?: string[];
}

export interface DeliveryAddonDefaults {
  selected?: boolean;
}

export interface DeliveryAddonLocalization {
  description?: string;
  name?: string;
}

export interface DeliveryAddonPrice {
  /** Value is CEL expression, which should evaluate to the price. */
  value?: string;
  /** @format float */
  vat_rate?: number;
}

/**
 * DeliveryChain contains details of a multi-stage delivery, ie. that it is a result of a multiple deliveries
 * (with possibly different shipping methods) chained to each other.
 */
export interface DeliveryChain {
  /** FirstMile represents the first step of a chained delivery. */
  first_mile?: ChainStep;
  /** LastMiles represent all the possible options for the second step of a chained delivery. */
  last_miles?: ChainStep[];
}

export interface DeliveryTime {
  /** @format int32 */
  max?: number;
  /** @format int32 */
  min?: number;
  unit?: string;
}

/**
 * Helper properties that are passed to the service widget
 * and used for delivery time formatting and overwriting some values.
 */
export interface DeliveryTimeProperties {
  /** Bypass all formatting logic, just render the custom text. */
  custom_text?: string;
  /**
   * Formats of date to display in the widget.
   * Values: days, date, weekday, weekday_date, weeks, weeks_numbers.
   */
  format?: string;
  /**
   * Ignore cutoffs in timeslot calculation.
   * Normally timeslot is calculated: closest cutoff time + delivery time.
   * By setting ignore_cutoffs to true we calculate timeslot just by adding delivery time to current time.
   */
  ignore_cutoffs?: boolean;
  keep_delivery_time_after_address?: boolean;
  /** Localization strings for delivery time texts */
  localization?: Record<string, DeliveryTimePropertiesLocalization>;
  /**
   * Decides whether widget should show delivery time as range between dates or just start (min) or end (max) date.
   * Values: interval, min, max.
   */
  range?: TimeFormatting;
  /** Timespan to be used before address is submitted. */
  timespan?: Timespan;
  /** Flag describing whether we should use timespan in delivery time rendering. */
  use_timespan?: boolean;
}

export interface DeliveryTimePropertiesLocalization {
  custom_text?: string;
}

/**
 * Indicates the type of the delivery
 * - UNKNOWN: Delivery type is not known for some reason
 *  - DELIVERY: Home delivery
 *  - PICKUP: Delivery to a service point or a locker
 *  - MAILBOX: Delivery to customer's mailbox
 *  - INSTORE: Delivery to one of the merchants stores
 *  - INWAREHOUSE: Delivery to the warehouse. This type is used with chain delivery in warehouse-warehouse-delivery/pickup.
 * @default "UNKNOWN"
 */
export type DeliveryType = "UNKNOWN" | "DELIVERY" | "PICKUP" | "MAILBOX" | "INSTORE" | "INWAREHOUSE";

export interface DeliveryUpsellWidgetConfig {
  bar_color?: string;
  bar_color_success?: string;
  custom_font_url?: string;
  enable_currency_symbol?: boolean;
  font_family?: string;
  /** @format int32 */
  font_size?: number;
  ignored_categories?: string[];
}

export interface DeliveryUpsellWidgetConfiguration {
  by_country?: Record<string, DeliveryUpsellWidgetFeatures>;
  features?: DeliveryUpsellWidgetFeatures;
  show_ingrid_logo?: boolean;
}

export interface DeliveryUpsellWidgetFeatures {
  bar_color?: string;
  bar_color_success?: string;
  bar_visibility?: boolean;
  carrier_logos?: MethodList;
  custom_font_url?: string;
  disable_padding?: boolean;
  display_currency_iso_code?: boolean;
  enable_analytics?: boolean;
  enable_animation?: boolean;
  enable_bar_border_padding?: boolean;
  enable_bar_border_radius?: boolean;
  enable_free_shipping_indicator?: boolean;
  enable_free_shipping_indicator_category_name_message?: boolean;
  enable_icon?: boolean;
  enable_upfront_shipping_price?: boolean;
  enable_uppercase_text?: boolean;
  font_family?: string;
  /** @format int32 */
  font_size?: number;
  /** @format int32 */
  font_weight?: number;
  free_shipping_indicator_message?: FreeShippingIndicatorMessage;
  hide_free_text?: boolean;
  ignored_categories?: CategoryList;
  show_carrier_logos?: boolean;
}

export interface Draft {
  /**
   * IsDraft specifies that this site is a draft. Services can base logic on this property. For example
   * EDI files shouldn't be send to production FTP server or SMS notifications shouldn't be send to the users.
   */
  is_draft?: boolean;
  /**
   * MasterSiteId specifies master of this draft. Services can base logic on this property. For example if translations
   * are not available for site X, some service can choose to check translations for .Draft.MasterSiteId.
   */
  master_site_id?: string;
}

export interface EmbeddedWidgetIngrid {
  logo?: IngridLogo;
}

export interface EventTypes {
  custom?: CustomEventType[];
  internal?: InternalEventType[];
  state?: State;
}

export interface Expression {
  value?: string;
  __type?: ExpressionType;
}

/** @default "UNKNOWN_EXPRESSION" */
export type ExpressionType = "UNKNOWN_EXPRESSION" | "JSON_LOGIC" | "CEL_GO";

export interface FaqWidgetByCountryConfiguration {
  features?: FaqWidgetFeatures;
}

export interface FaqWidgetConfiguration {
  by_country?: Record<string, FaqWidgetByCountryConfiguration>;
  features?: FaqWidgetFeatures;
}

export interface FaqWidgetFeatures {
  accent_color_1?: string;
  alter_ics_delivery_message?: boolean;
  display_currency_iso_code?: boolean;
  enable_accent_color_for_widget_elements?: boolean;
  enable_country_selector?: boolean;
  enable_fx_converter?: boolean;
  enable_price_zero_value?: boolean;
  enable_widget_border?: boolean;
  ignored_categories?: string[];
  make_widget_transparent?: boolean;
  show_carrier_icons?: boolean;
  show_currency_before_price?: boolean;
  show_delivery_times_as_estimates?: boolean;
}

export interface FeatureRollout {
  /** Controls whether the rollout is enabled or not */
  enabled?: BoolOptionV2;
  /**
   * Incremented whenever rollout parameters are changed and cached decisions should be invalidated.
   * The frontend can store this alongside the assignment and reset when it detects a version change.
   * @format int32
   */
  revision?: number;
  /**
   * Set of variants that the traffic will be divided based on the `traffic` parameter.
   * TODO: validation maybe needed to ensure that `sum(variants.traffic) == 1000`
   */
  variants?: FeatureRolloutVariant[];
}

export interface FeatureRolloutVariant {
  /**
   * Permil (1/1000) of visitors that will be assigned to the "feature".
   * @format int32
   */
  traffic?: number;
  /**
   * Value to apply when this rollout is active
   * Eg, when used with:
   * - for ui_version contains the UI version identifier
   * - for survey contains the survey name
   */
  value?: StringOptionV2;
}

export interface Features {
  alter_ics_delivery_message?: boolean;
  autocomplete_street?: boolean;
  dark_color_enabled?: boolean;
  disable_address_form?: boolean;
  disable_choice_lost_modal_if_similar_selected?: boolean;
  display_currency_iso_code?: boolean;
  display_location_type?: boolean;
  display_upfront_address?: boolean;
  /** Use require_street_on_address_module instead. */
  dont_require_street_on_address_fields?: boolean;
  door_code?: boolean;
  enable_accent_color_for_widget_elements?: boolean;
  enable_addon_new_presentation?: boolean;
  enable_analytics?: boolean;
  enable_country_input_placeholder?: boolean;
  enable_country_selector?: boolean;
  enable_free_shipping_indicator?: boolean;
  enable_free_shipping_indicator_carrier_logo?: boolean;
  enable_free_shipping_indicator_category_name_message?: boolean;
  enable_high_contrast?: boolean;
  enable_ingrid_logo?: boolean;
  enable_multiple_home_delivery_in_category?: boolean;
  enable_postal_code_in_location_address?: boolean;
  enable_price_zero_value?: boolean;
  enable_short_delivery_times?: boolean;
  enable_transparent_background?: boolean;
  enable_widget_border?: boolean;
  /** Use show_street_on_address_module instead. */
  hide_street_on_address_fields?: boolean;
  hide_toc?: boolean;
  new_search_address?: boolean;
  require_region?: boolean;
  require_street_on_address_module?: boolean;
  /**
   * Value 0 indicates that shipping categories folding is disabled.
   * @format int64
   */
  shipping_categories_visible_when_folded_count?: number;
  show_base_price?: boolean;
  show_billing_address?: boolean;
  show_cancel_button_on_modal?: boolean;
  show_carrier_icons?: boolean;
  show_carrier_logos_in_shipping_categories_placeholder?: boolean;
  /** Use show_city_on_address_module instead. */
  show_city_on_address_fields?: boolean;
  show_city_on_address_module?: boolean;
  show_currency_before_price?: boolean;
  show_delivered_by?: boolean;
  show_delivery_times_as_estimates?: boolean;
  show_map?: boolean;
  show_privacy_policy?: boolean;
  show_region?: boolean;
  show_shipping_categories_before_address?: boolean;
  show_shipping_options_header?: boolean;
  show_shipping_price_on_service_points_view?: boolean;
  show_slogan?: boolean;
  show_state_on_address_fields?: boolean;
  show_street_on_address_module?: boolean;
}

export interface FilterRule {
  condition?: string;
}

/** @default "FREE_SHIPPING_INDICATOR_MESSAGE_UNKNOWN" */
export type FreeShippingIndicatorMessage =
  | "FREE_SHIPPING_INDICATOR_MESSAGE_UNKNOWN"
  | "FREE_SHIPPING_INDICATOR_MESSAGE_CATEGORY_NAME"
  | "FREE_SHIPPING_INDICATOR_MESSAGE_DELIVERY_TYPE"
  | "FREE_SHIPPING_INDICATOR_MESSAGE_BASIC";

export interface FrozenFieldsAfterPrefill {
  fields?: AddressFormFieldName[];
}

export interface GenerateNewPrivateKeyForSiteRequest {
  label?: string;
  site_id?: string;
}

export interface GenerateNewPrivateKeyForSiteResponse {
  site?: Site;
}

export interface GeoArea {
  active?: boolean;
  country?: string;
  id?: string;
  matchers?: GeoAreaMatcher[];
  name?: string;
}

export interface GeoAreaMatcher {
  inverse?: boolean;
  patterns?: string[];
  regexes?: string[];
  type?: GeoAreaMatcherType;
}

/** @default "MATCHER_UNSPECIFIED" */
export type GeoAreaMatcherType = "MATCHER_UNSPECIFIED" | "MATCHER_POSTAL_CODE" | "MATCHER_CITY";

export interface GetCarrierAddonsResponse {
  addons?: Addon[];
  categories?: Category[];
}

export interface GetMerchantResponse {
  merchant?: Merchant;
}

export interface GetPrivateKeyResponse {
  private_key?: string;
}

export interface GetShippingMethodsResponse {
  methods?: ShippingMethod[];
}

export interface GetSiteResponse {
  config_type?: ConfigType;
  /** Metadata informs client, how was the response obtained. */
  metadata?: GetSiteResponseMetadata;
  site?: Site;
}

/** Metadata informs client, how was the response obtained. */
export interface GetSiteResponseMetadata {
  /** source explains where was the response fetched from. */
  source?: string;
}

/**
 * HTTP method to use when sending the request (defaults to POST if unspecified).
 * @default "METHOD_UNSPECIFIED"
 */
export type HttpAdditionalConfigurationMethod = "METHOD_UNSPECIFIED" | "POST" | "PUT" | "PATCH" | "DELETE";

export interface HttpGlobalConfigurationProxy {
  enabled?: boolean;
  insecure_skip_verify?: boolean;
  url?: string;
}

export interface InfobipEmailOptions {
  sender_address?: string;
  sender_name?: string;
}

export interface InfobipSMSOptions {
  sender_name?: string;
  url_options?: SMSOptionsURLOptions;
}

export interface IngridLogo {
  disabled?: BoolOptionV2;
}

/**
 * An integer value
 * integer value or an Expression. The client code must handle both cases.
 * @format int32
 */
export type Int32Option = number;

export interface Int32OptionV2 {
  /** An expression that dynamically determines the value. */
  expression?: Expression;
  /**
   * An integer value
   * @format int32
   */
  value?: number;
}

export interface InternalEventType {
  id?: Status;
  state?: State;
}

export interface Label {
  color?: string;
  dark_mode_color?: string;
  icon?: string;
  id?: string;
  /** Localization contains name and description per locale. */
  localization?: Record<string, LabelLocalization>;
  name?: string;
  state?: State;
  type?: LabelType;
}

/**
 * LabelConfiguration holds site-specific options for
 * labels.
 */
export interface LabelConfiguration {
  /** The layout to use for error labels */
  error_layout?: string;
}

export interface LabelLocalization {
  description?: string;
  name?: string;
}

/** @default "LABEL_TYPE_UNKNOWN" */
export type LabelType =
  | "LABEL_TYPE_UNKNOWN"
  | "LABEL_TYPE_SUSTAINABILITY"
  | "LABEL_TYPE_PRIORITY"
  | "LABEL_TYPE_CUSTOM"
  | "LABEL_TYPE_SWAN";

export interface ListMerchantsResponse {
  merchants?: MerchantSummary[];
}

export interface Merchant {
  id?: string;
  name?: string;
  sites?: Site[];
}

export interface MerchantSummary {
  id?: string;
  name?: string;
  sites?: SiteSummary[];
}

export interface Metadata {
  draft?: Draft;
  /** Read only field. */
  is_standard?: boolean;
  /**
   * IsVerified specifies that the structure of the site has been validated.
   * Once set to true it is not supposed to ever be unset.
   */
  is_verified?: boolean;
  test_variant?: TestVariant;
  /** Volatile flag indicates that the site is not related to any real-life merchant and can be safely deleted from DB. */
  volatile?: boolean;
}

export interface Method {
  /**
   * - UNKNOWN: Delivery type is not known for some reason
   *  - DELIVERY: Home delivery
   *  - PICKUP: Delivery to a service point or a locker
   *  - MAILBOX: Delivery to customer's mailbox
   *  - INSTORE: Delivery to one of the merchants stores
   *  - INWAREHOUSE: Delivery to the warehouse. This type is used with chain delivery in warehouse-warehouse-delivery/pickup.
   */
  delivery_type?: DeliveryType;
  rules?: Rule[];
  shipping_method?: string;
}

export interface MethodList {
  methods?: string[];
}

export interface MovePrivateKeyRequest {
  dest_site_id?: string;
  label?: string;
  source_site_id?: string;
}

/**
 *  - SMS_CHANNEL: Ingrid internal SMS Channel.
 *  - EMAIL_CHANNEL: Ingrid internal email Channel.
 *  - CEP_CHANNEL: Customer Engagement Platform channel.
 *  - REVIEW_PLATFORM_CHANNEL: Review Platform channel.
 *  - INFOBIP_SMS_CHANNEL: Infobip provider SMS channel.
 *  - INFOBIP_EMAIL_CHANNEL: Infobip provider email channel.
 *  - API_NOTIFICATION_CHANNEL: API Notification channel.
 *  - KLAVIYO_CHANNEL: Klaviyo channel.
 *  - VOYADO_CHANNEL: Voyado channel.
 * @default "NOTIFICATION_CHANNEL_TYPE_UNKNOWN"
 */
export type NotificationChannelType =
  | "NOTIFICATION_CHANNEL_TYPE_UNKNOWN"
  | "SMS_CHANNEL"
  | "EMAIL_CHANNEL"
  | "CEP_CHANNEL"
  | "REVIEW_PLATFORM_CHANNEL"
  | "INFOBIP_SMS_CHANNEL"
  | "INFOBIP_EMAIL_CHANNEL"
  | "API_NOTIFICATION_CHANNEL"
  | "KLAVIYO_CHANNEL"
  | "VOYADO_CHANNEL";

/** @default "UNKNOWN_KIND" */
export type NotificationKind =
  | "UNKNOWN_KIND"
  | "PROGRESS_KIND"
  | "PICKUP_REMINDER_KIND"
  | "ORDER_RECEIPT_KIND"
  | "ORDER_CANCELLED_BY_MERCHANT_KIND"
  | "ORDER_CANCELLED_BY_CUSTOMER_KIND"
  | "ORDER_ITEMS_CANCELLED_KIND"
  | "RETURN_RECEIPT_KIND"
  | "OUT_FOR_DELIVERY_KIND"
  | "DELIVERY_DELAYED_KIND"
  | "DELIVERY_FAILED_KIND"
  | "CENTRA_ORDER_CONFIRMED_KIND"
  | "SUBMISSION_DELAYED_KIND"
  | "PRICE_ADJUSTMENT_RECEIPT_KIND"
  | "RETURNED_IN_STORE_KIND"
  | "RETURNED_TO_WAREHOUSE_KIND"
  | "PARCEL_REFUSED_NO_REASON"
  | "PARCEL_REFUSED_NOT_WANTED"
  | "PARCEL_REFUSED_GOODS_DAMAGED"
  | "PARCEL_REFUSED_PACKAGING_DAMAGED"
  | "PARCEL_NOT_COLLECTED"
  | "PAYMENT_DECLINED_KIND"
  | "REMAINING_SHIPMENTS_CANCELLED_KIND"
  | "PAYMENT_DECLINED_FRAUD_CHECK_KIND"
  | "TRACKING_RULES_NOTIFICATION_KIND";

export interface OperatingScheduleCarrierItem {
  carrier_cutoff?: boolean;
  cutoffs_plan?: CutoffsItem[];
}

export interface OperatingScheduleCutoffTimes {
  times?: string[];
}

export interface OperatingScheduleException {
  cutoff_times?: string[];
  valid_from?: string;
  valid_until?: string;
}

export interface OperatingScheduleItem {
  /** carrier_cutoff indicates if the cutoff is handled by the carrier. */
  carrier_cutoff?: boolean;
  cutoff_times?: Record<string, OperatingScheduleCutoffTimes>;
  /**
   * TODO: Add it when we need it.
   * repeated OperatingScheduleRule operating_schedule_rules = 2;
   */
  operating_schedule_exceptions?: OperatingScheduleException[];
}

/**
 *  - NONE: None indicates that parcels are not available for shipping method.
 * @default "UNKNOWN"
 */
export type ParcelType = "UNKNOWN" | "NONE" | "LETTER" | "PACKAGE" | "PALLET";

/**
 * Indicates the kind of pickup location
 * - UNKNOWN_PICKUP_LOCATION_TYPE: Location type is not known for some reason
 *  - LOCKER: Locker location type. Example Instabox or a DHL locker
 *  - STORE: Can be a merchant's store or any other store that handles logistics
 *  - POSTOFFICE: Postal office
 *  - MANNED: A manned service point
 * @default "UNKNOWN_PICKUP_LOCATION_TYPE"
 */
export type PickupLocationType = "UNKNOWN_PICKUP_LOCATION_TYPE" | "LOCKER" | "STORE" | "POSTOFFICE" | "MANNED";

/**
 * PickupReminderSettings contains settings for pickup reminders.
 * - `enabled`: Indicates whether pickup reminders are enabled.
 * - `thresholds`: Specifies a list of duration thresholds for sending reminders after package is ready to be collected.
 */
export interface PickupReminderSettings {
  enabled?: boolean;
  /**
   * Available formats for Pickup Reminder thresholds:
   * - Durations adhering to Go's time.ParseDuration function (e.g., "1h30m" for 1 hour and 30 minutes).
   * - Valid units include "ns", "us", "ms", "s", "m", and "h" (nanoseconds to hours).
   */
  thresholds?: string[];
}

export interface PostProcessingRule {
  actions?: Action[];
  apply_rules?: FilterRule[];
  name?: string;
  selections?: Selection[];
}

export interface PredefinedShippingOption {
  delivery_time?: string;
}

export interface PreselectedChoiceRule {
  contains_all?: CondContainsAll;
  shipping_method?: string;
}

export interface Price {
  /** @format int32 */
  amount?: number;
  currency?: string;
}

export interface PriceComponent {
  /** Name of the element, eg. "shipping cost" or "unwrapping". */
  name?: string;
  /** Value contains the price rule expression. */
  value?: string;
}

export interface PriceRule {
  condition?: string;
  conditions?: string[];
  /** @format int32 */
  price?: number;
  valid_from?: string;
  valid_until?: string;
}

export interface Prices {
  prices?: Price[];
}

/** Representation of a private key (used for authorization) that is identified with a human-recognizable label. */
export interface PrivateKey {
  label?: string;
  value?: string;
}

export interface ProductFataFeed {
  enabled?: boolean;
}

export interface ProductPageWidgetByCountryConfiguration {
  features?: ProductPageWidgetFeatures;
}

export interface ProductPageWidgetConfiguration {
  by_country?: Record<string, ProductPageWidgetByCountryConfiguration>;
  features?: ProductPageWidgetFeatures;
}

export interface ProductPageWidgetFeatures {
  accent_color?: string;
  alter_ics_delivery_message?: boolean;
  custom_font_family_name?: string;
  custom_font_family_url?: string;
  disable_ingrid_logo?: boolean;
  display_categories_without_postal_code?: boolean;
  enable_analytics?: boolean;
  enable_short_delivery_times?: boolean;
  /** @format int32 */
  font_size_primary?: number;
  /** @format int32 */
  font_size_secondary?: number;
  /** @format int32 */
  font_weight_default?: number;
  /** @format int32 */
  font_weight_stronger?: number;
  hide_carrier_logos_pre_categories?: boolean;
  neutral_color?: string;
  preserve_postal_code?: boolean;
  secondary_color?: string;
  /**
   * Value 0 indicates that shipping categories folding is disabled.
   * @format int64
   */
  shipping_categories_visible_when_folded_count?: number;
  show_delivery_times_as_estimates?: boolean;
}

export interface ReceiptWidgetByCountryConfiguration {
  features?: ReceiptWidgetFeatures;
}

export interface ReceiptWidgetConfiguration {
  by_country?: Record<string, ReceiptWidgetByCountryConfiguration>;
  features?: ReceiptWidgetFeatures;
}

export interface ReceiptWidgetFeatures {
  delivery?: ReceiptWidgetFeaturesDelivery;
  footer?: ReceiptWidgetFeaturesFooter;
  header?: ReceiptWidgetFeaturesSection;
  order_details?: ReceiptWidgetFeaturesSectionWithHeader;
  order_summary?: ReceiptWidgetFeaturesSectionWithHeader;
  rating?: ReceiptWidgetFeaturesSectionWithHeader;
}

export interface ReceiptWidgetFeaturesDelivery {
  enable_header?: boolean;
  enable_section?: boolean;
  is_courier_instructions_editable?: boolean;
  is_door_code_editable?: boolean;
}

export interface ReceiptWidgetFeaturesFooter {
  enable_ingrid_logo?: boolean;
  enable_section?: boolean;
  show_privacy_policy?: boolean;
  show_slogan?: boolean;
}

export interface ReceiptWidgetFeaturesSection {
  enable_section?: boolean;
}

export interface ReceiptWidgetFeaturesSectionWithHeader {
  enable_header?: boolean;
  enable_section?: boolean;
}

export interface Region {
  carrier_products?: CarrierProduct[];
  created_at?: string;
  currency?: string;
  features?: RegionFeatures;
  group_id?: string;
  id?: string;
  name?: string;
  region_country_config?: RegionCountryConfig;
  region_postal_code_config?: RegionPostalCodeConfig;
  region_type?: string;
  state?: State;
  status?: Status;
  /** settings used to calculate and present net and gross delivery prices in the delivery widget */
  taxes_settings?: TaxesSettings;
  warehouse_id?: string;
}

export interface RegionCountryConfig {
  excluded?: string[];
  included?: string[];
}

export interface RegionFeatures {
  enable_country_selector?: boolean;
  enable_price_based_category_sorting?: boolean;
  show_high_demand_affects_delivery_disclaimer_message?: boolean;
}

export interface RegionPostalCodeConfig {
  country?: string;
  excluded_postal_codes?: string[];
  postal_codes?: string[];
}

export interface RenameMerchantRequest {
  id?: string;
  name?: string;
}

export type RenameMerchantResponse = object;

export interface RenameSiteRequest {
  name?: string;
  site_id?: string;
}

export type RenameSiteResponse = object;

export interface Rule {
  expression?: string;
  name?: string;
}

export interface SMSOptionsURLOptions {
  custom_domain?: string;
  remove_protocol?: boolean;
  shorten_url?: boolean;
}

/** SectionsConfig describes the sections that should be shown on the widget. */
export interface SectionsConfig {
  cart_items?: SectionsConfigCartItems;
  delivery_details?: SectionsConfigDeliveryDetails;
  eta_header?: SectionsConfigETAHeader;
  footer?: SectionsConfigFooter;
  info_box?: SectionsConfigInfoBox;
  info_boxes?: SectionsConfigInfoBox[];
  map?: SectionsConfigMap;
  navigation_header?: SectionsConfigNavigationHeader;
  navigation_header_multiparcel?: SectionsConfigNavigationHeaderMultiparcel;
  tracking_progress?: SectionsConfigTrackingProgress;
}

export interface SectionsConfigCartItems {
  /** Determines if the item should be initially expanded by default. */
  default_expanded?: BoolOption;
  /** Disabled indicates that the cart items section should not be shown. */
  disabled?: BoolOption;
  /** Indicates whether the toggle for expanding/collapsing section is disabled. */
  expand_toggle_disabled?: BoolOption;
  /** A number representing the order of the section, indicating its position in a sequence. */
  order?: Int32Option;
  /** Toggles the display of images for the cart items. */
  show_images?: BoolOption;
  /** Toggles the visibility of individual cart item prices. */
  show_prices?: BoolOption;
  /** Toggles the display of the order summary, including the total price, delivery information, and additional services. */
  show_summary?: BoolOption;
}

export interface SectionsConfigDeliveryDetails {
  /** Determines if the item should be initially expanded by default. */
  default_expanded?: BoolOption;
  /** Disabled indicates that the delivery section should not be shown. */
  disabled?: BoolOption;
  /** Indicates whether the toggle for expanding/collapsing section is disabled. */
  expand_toggle_disabled?: BoolOption;
  /** A number representing the order of the section, indicating its position in a sequence. */
  order?: Int32Option;
}

export interface SectionsConfigETAHeader {
  /** Control whether ETA header alerts should be disabled. */
  disable_alerts?: BoolOption;
  /** Controls whether ETA header dates should be disabled. */
  disable_dates?: BoolOption;
  /** Disabled indicates that the ETA header should not be shown. */
  disabled?: BoolOption;
}

export interface SectionsConfigFooter {
  /** Disabled indicates that the footer should not be shown. */
  disabled?: BoolOption;
}

export interface SectionsConfigInfoBox {
  /** Disabled indicates that the infobox should not be shown. */
  disabled?: BoolOption;
  /** The field represents the label displayed on the infobox. For example date. */
  label?: StringOption;
  /** The field represents the message displayed on the infobox. */
  message?: StringOption;
}

export interface SectionsConfigMap {
  /** Disabled indicates that the map should not be shown. */
  disabled?: BoolOption;
  /** A number representing the order of the section, indicating its position in a sequence. */
  order?: Int32Option;
}

export interface SectionsConfigNavigationHeader {
  /** Indicates whether the navigation is disabled on the order level, preventing users from returning to search mode. */
  disabled?: BoolOption;
}

export interface SectionsConfigNavigationHeaderMultiparcel {
  /** Indicates whether the navigation is disabled on the parcel level of a multi-parcel order, preventing users from returning to the parcel list. */
  disabled?: BoolOption;
}

export interface SectionsConfigTrackingProgress {
  /** Determines if the item should be initially expanded by default. */
  default_expanded?: BoolOption;
  /** Disabled indicates that the tracking progress section should not be shown. */
  disabled?: BoolOption;
  /** Indicates whether the toggle for expanding/collapsing section is disabled. */
  expand_toggle_disabled?: BoolOption;
  /** A number representing the order of the section, indicating its position in a sequence. */
  order?: Int32Option;
}

/** SectionsConfig describes the sections that should be shown on the widget. */
export interface SectionsConfigV2 {
  cart_items?: SectionsConfigV2CartItems;
  delivery_details?: SectionsConfigV2DeliveryDetails;
  eta_header?: SectionsConfigV2ETAHeader;
  footer?: SectionsConfigV2Footer;
  info_box?: SectionsConfigV2InfoBox;
  info_boxes?: SectionsConfigV2InfoBox[];
  map?: SectionsConfigV2Map;
  navigation_header?: SectionsConfigV2NavigationHeader;
  navigation_header_multiparcel?: SectionsConfigV2NavigationHeaderMultiparcel;
  tracking_progress?: SectionsConfigV2TrackingProgress;
}

export interface SectionsConfigV2CartItems {
  /** Determines if the item should be initially expanded by default. */
  default_expanded?: BoolOptionV2;
  /** Disabled indicates that the cart items section should not be shown. */
  disabled?: BoolOptionV2;
  /** Indicates whether the toggle for expanding/collapsing section is disabled. */
  expand_toggle_disabled?: BoolOptionV2;
  /** A number representing the order of the section, indicating its position in a sequence. */
  order?: Int32OptionV2;
  /** Toggles the display of images for the cart items. */
  show_images?: BoolOptionV2;
  /** Toggles the visibility of individual cart item prices. */
  show_prices?: BoolOptionV2;
  /** Toggles the display of the order summary, including the total price, delivery information, and additional services. */
  show_summary?: BoolOptionV2;
}

export interface SectionsConfigV2DeliveryDetails {
  /** Determines if the item should be initially expanded by default. */
  default_expanded?: BoolOptionV2;
  /** Controls whether the location/address should be disabled. */
  disable_location?: BoolOptionV2;
  /** Disabled indicates that the delivery section should not be shown. */
  disabled?: BoolOptionV2;
  /** Indicates whether the toggle for expanding/collapsing section is disabled. */
  expand_toggle_disabled?: BoolOptionV2;
  /** A number representing the order of the section, indicating its position in a sequence. */
  order?: Int32OptionV2;
}

export interface SectionsConfigV2ETAHeader {
  /** Control whether ETA header alerts should be disabled. */
  disable_alerts?: BoolOptionV2;
  /** Controls whether ETA header dates should be disabled. */
  disable_dates?: BoolOptionV2;
  /** Disabled indicates that the ETA header should not be shown. */
  disabled?: BoolOptionV2;
}

export interface SectionsConfigV2Footer {
  /** Disabled indicates that the footer should not be shown. */
  disabled?: BoolOptionV2;
}

export interface SectionsConfigV2InfoBox {
  /** Disabled indicates that the infobox should not be shown. */
  disabled?: BoolOptionV2;
  /** The field represents the label displayed on the infobox. For example date. */
  label?: StringOptionV2;
  /** The field represents the message displayed on the infobox. */
  message?: StringOptionV2;
}

export interface SectionsConfigV2Map {
  /** Disabled indicates that the map should not be shown. */
  disabled?: BoolOptionV2;
  /** A number representing the order of the section, indicating its position in a sequence. */
  order?: Int32OptionV2;
}

export interface SectionsConfigV2NavigationHeader {
  /** Indicates whether the navigation is disabled on the order level, preventing users from returning to search mode. */
  disabled?: BoolOptionV2;
}

export interface SectionsConfigV2NavigationHeaderMultiparcel {
  /** Indicates whether the navigation is disabled on the parcel level of a multi-parcel order, preventing users from returning to the parcel list. */
  disabled?: BoolOptionV2;
}

export interface SectionsConfigV2TrackingProgress {
  /** Determines if the item should be initially expanded by default. */
  default_expanded?: BoolOptionV2;
  /** Disabled indicates that the tracking progress section should not be shown. */
  disabled?: BoolOptionV2;
  /** Indicates whether the toggle for expanding/collapsing section is disabled. */
  expand_toggle_disabled?: BoolOptionV2;
  /** A number representing the order of the section, indicating its position in a sequence. */
  order?: Int32OptionV2;
}

export interface Selection {
  expression?: string;
}

export interface ServiceConfiguration {
  configuration_data?: string;
  configuration_type?: string;
  id?: string;
}

/**
 * SessionPostProcessing can be used to modify session using configuration.
 * For currently supported action check proto/common/postprocess_session.
 */
export interface SessionPostProcessing {
  /**
   * ShippingOptionsRules can be used to define post processing rules
   * which operates on shipping options.
   * Example:
   * name: hide pnl-mpc if pnl-bua exists
   * apply_rules: session.shipping_options.exists(x, x.shipping_method == 'pnl-bua')
   * selections: [
   *    expression: shipping_option.shipping_method == "pnl-mpc"
   *    expression: shipping_option.delivery_type == "pickup"
   * ]
   * action: remove()
   */
  shipping_options_rules?: PostProcessingRule[];
}

export interface SessionRetentionConfiguration {
  /**
   * How many days after closing the session the session expires/will be deleted or anonymized.
   * @format int32
   */
  closed_expiry_days?: number;
  /**
   * How many days after last activity the session expires/will be deleted or anonymized.
   * @format int32
   */
  idle_expiry_days?: number;
}

export interface ShippingCategory {
  additional_options?: ShippingCategoryAdditionalOptions;
  carrier_logos?: Record<string, string>;
  country_settings?: Record<string, CategoryCountrySettings>;
  created_at?: string;
  custom_discount_info_text?: string;
  custom_info_text?: string;
  custom_text?: string;
  custom_unavailable_text?: string;
  custom_warning_text?: string;
  default_delivery_time_for_country?: Record<string, DeliveryTime>;
  /** Deprecated in favor of default_cost. [deprecated] */
  default_prices?: Record<string, number>;
  /** DefaultShippingPricing is a list of default prices in multiple currencies for given shipping method. */
  default_shipping_pricing?: Record<string, Prices>;
  delivery_addons?: DeliveryAddon[];
  /** DeliveryChain contains details of all the possible combinations of delivery phases if a delivery chain is possible. */
  delivery_chain?: DeliveryChain;
  delivery_time?: DeliveryTime;
  /** DeliveryTimeProperties contains various helper properties that are passed to the service widget. */
  delivery_time_properties?: DeliveryTimeProperties;
  /**
   * - UNKNOWN: Delivery type is not known for some reason
   *  - DELIVERY: Home delivery
   *  - PICKUP: Delivery to a service point or a locker
   *  - MAILBOX: Delivery to customer's mailbox
   *  - INSTORE: Delivery to one of the merchants stores
   *  - INWAREHOUSE: Delivery to the warehouse. This type is used with chain delivery in warehouse-warehouse-delivery/pickup.
   */
  delivery_type?: DeliveryType;
  delivery_type_text?: string;
  external_id?: string;
  filter_rules?: FilterRule[];
  group_id?: string;
  id?: string;
  labels?: Label[];
  localization?: Record<string, ShippingCategoryLocalization>;
  /**
   * Maximum number of choices to be returned in the category. Zero value indicates no limit.
   * @format int32
   */
  max_choices_count?: number;
  name?: string;
  pickup_location_types?: PickupLocationType[];
  /** Deprecated in favor of country_settings. [deprecated] */
  preselected?: boolean;
  /**
   * Deprecated in favor of default_prices. [deprecated]
   * @format int32
   */
  price?: number;
  region_ids?: string[];
  requirements?: ShippingCategoryRequirements;
  shipping_methods?: string[];
  show_on_faq_widget?: boolean;
  /** @format int32 */
  sort_order?: number;
  state?: State;
  /** Status is derived from state, with unknown state being considered as active. */
  status?: Status;
  tags?: Tag[];
  /** TODO: Move time_formatting to delivery_time_properties. */
  time_formatting?: TimeFormatting;
  virtual_method?: VirtualMethod;
}

export interface ShippingCategoryAdditionalOptions {
  instore_search_options?: AdditionalOptionsInstoreSearch;
}

export interface ShippingCategoryLocalization {
  custom_discount_info_text?: string;
  custom_info_text?: string;
  custom_text?: string;
  custom_warning_text?: string;
  name?: string;
}

export interface ShippingCategoryRequirements {
  address?: boolean;
  confirm_shipping_option_on_complete?: boolean;
  customer_number?: boolean;
  enable_additional_location_info?: boolean;
  enable_choice_selection?: boolean;
  hide_shipping_options?: boolean;
  show_carrier_logos?: boolean;
  show_carrier_logos_on_map_pin?: boolean;
  use_price_from?: boolean;
}

export interface ShippingDateAdjustment {
  /** @format int32 */
  adjust_end?: number;
  /** @format int32 */
  adjust_start?: number;
  unit?: string;
}

export interface ShippingMethod {
  carrier?: string;
  delivery_types?: DeliveryType[];
  id?: string;
  name?: string;
  /**  - NONE: None indicates that parcels are not available for shipping method. */
  parcel_type?: ParcelType;
  /** SelfConfigurable determines if this shipping method can be configured for site by user with proper permissions. */
  self_configurable?: boolean;
}

export interface ShippingOptionConfiguration {
  courier_instructions?: boolean;
  delivery_time_unit?: string;
  door_code?: boolean;
  searchable?: boolean;
}

export interface Site {
  address_form_configuration?: AddressFormConfiguration;
  booking?: Booking;
  booking_enabled?: boolean;
  created_at?: string;
  custom_booking_methods?: CustomBookingMethod[];
  custom_shipping_methods?: CustomShippingMethods;
  data_retention_configuration?: DataRetentionConfiguration;
  default_receiver_contact?: ContactData;
  default_sender_contact?: ContactData;
  delivery_upsell_widget_config?: DeliveryUpsellWidgetConfig;
  delivery_upsell_widget_configuration?: DeliveryUpsellWidgetConfiguration;
  faq_widget_configuration?: FaqWidgetConfiguration;
  geo_areas?: GeoArea[];
  id?: string;
  /**
   * LabelConfiguration holds site-specific options for
   * labels.
   */
  label_configuration?: LabelConfiguration;
  /** Identifies parent merchant. This is read-only field. */
  merchant_id?: string;
  metadata?: Metadata;
  name?: string;
  /** OmbudShippingMethods lists all ombud methods that can be configured for this site. */
  ombud_shipping_methods?: string[];
  preselected_choice_rules?: PreselectedChoiceRule[];
  /** Use private_keys instead. */
  private_key?: string;
  /** List of private keys associated with a site and its potential drafts. */
  private_keys?: PrivateKey[];
  product_data_feed?: ProductFataFeed;
  product_page_widget_configuration?: ProductPageWidgetConfiguration;
  receipt_widget_configuration?: ReceiptWidgetConfiguration;
  regions?: Region[];
  /** SendStateEvents determines if the backend will emit state change events, allowing for async frontend integration */
  send_state_events?: boolean;
  service_configurations?: ServiceConfiguration[];
  /** PostProcessingRules define rule which are executed before preselection in cos engine. */
  session_post_processing?: SessionPostProcessing;
  shipping_categories?: ShippingCategory[];
  sorting_rules?: SortingRule[];
  tracking?: Tracking;
  updated_at?: string;
  /** @format int64 */
  version?: string;
  warehouses?: Warehouse[];
  widget_configuration?: WidgetConfiguration;
}

export interface SiteSummary {
  id?: string;
  is_draft?: boolean;
  master_site_id?: string;
  metadata?: Metadata;
  name?: string;
  updated_at?: string;
  /** @format int64 */
  version?: string;
}

export type SortDrivingDist = object;

export interface SortDrivingDistanceThreshold {
  /** @format int32 */
  threshold?: number;
}

export type SortDrivingDuration = object;

export interface SortFavorCarrier {
  name?: string;
}

export interface SortFavorClosestFreeShippingOption {
  shipping_category?: string;
  shipping_method?: string;
}

export interface SortFavorClosestShippingOption {
  shipping_category?: string;
  shipping_method?: string;
}

export interface SortFavorClosestTimeDistanceFreeShippingOption {
  shipping_category?: string;
  shipping_method?: string;
}

export interface SortFavorClosestTimeDistanceShippingOption {
  shipping_category?: string;
  shipping_method?: string;
}

export type SortGeoDistance = object;

export type SortPrice = object;

export interface SortRespectCarrierLocationsOrder {
  /** If shipping_methods is set the SortRespectCarrierLocationsOrder will be applied only for particular shipping_method. */
  shipping_methods?: string[];
}

export type SortTimeSlot = object;

export type SortWalkingDist = object;

/**
 * SortWalkingDuration sorts choices based on walking duration. If either distance_threshold or duration_threshold is set,
 * it treats choices farther than the threshold as equal. If none of them is set, COS should use the default of distance_threshold = 1000.
 */
export interface SortWalkingDuration {
  /** @format int64 */
  distance_threshold?: string;
  /** @format int64 */
  duration_threshold?: string;
}

export interface SortingRule {
  conditional_sorting_rules_set?: ConditionalSortingRulesSet;
  driving_distance?: SortDrivingDist;
  driving_distance_threshold?: SortDrivingDistanceThreshold;
  favor_carrier?: SortFavorCarrier;
  favor_closest_free_shipping_option?: SortFavorClosestFreeShippingOption;
  favor_closest_shipping_option?: SortFavorClosestShippingOption;
  favor_closest_time_distance_free_shipping_option?: SortFavorClosestTimeDistanceFreeShippingOption;
  favor_closest_time_distance_shipping_option?: SortFavorClosestTimeDistanceShippingOption;
  lower_price?: SortPrice;
  sort_driving_duration?: SortDrivingDuration;
  sort_geo_distance?: SortGeoDistance;
  sort_respect_carrier_locations_order?: SortRespectCarrierLocationsOrder;
  /**
   * SortWalkingDuration sorts choices based on walking duration. If either distance_threshold or duration_threshold is set,
   * it treats choices farther than the threshold as equal. If none of them is set, COS should use the default of distance_threshold = 1000.
   */
  sort_walking_duration?: SortWalkingDuration;
  time_slot?: SortTimeSlot;
  walking_distance?: SortWalkingDist;
}

/** @default "UNKNOWN_TYPE" */
export type SpecRuleType = "UNKNOWN_TYPE" | "EXPR" | "CEL_GO";

/** @default "TARGET_UNSPECIFIED" */
export type SpecTargetType = "TARGET_UNSPECIFIED" | "ORDER_ALPHA1" | "PARCEL_ALPHA1";

/** @default "UNKNOWN" */
export type State = "UNKNOWN" | "INACTIVE" | "ACTIVE";

/** @default "INACTIVE" */
export type Status = "INACTIVE" | "ACTIVE";

/** @default "STEP_UNKNOWN" */
export type Step =
  | "STEP_UNKNOWN"
  | "STEP_CONFIRMED_BY_MERCHANT"
  | "STEP_PREPARED_BY_MERCHANT"
  | "STEP_SUBMITTED_TO_CARRIER"
  | "STEP_ON_ROUTE"
  | "STEP_DELIVERED_TO_PICKUP_POINT"
  | "STEP_DELIVERED_TO_CONSUMER"
  | "STEP_TERMINATED"
  | "STEP_SENT_BACK"
  | "STEP_RETURN_REQUESTED"
  | "STEP_DELIVERED_TO_MERCHANT"
  | "STEP_AWAITING_SUPPLIER"
  | "STEP_LINEHAUL_TO_CARRIER";

export interface StepExpression {
  expression?: string;
}

/**
 * A string value
 * string value or an Expression. The client code must handle both cases.
 */
export type StringOption = string;

export interface StringOptionV2 {
  /** An expression that dynamically determines the value. */
  expression?: Expression;
  /** A string value */
  value?: string;
}

export interface Style {
  accent_color_1?: string;
  accent_color_2?: string;
  color_button?: string;
  color_button_text?: string;
  color_checkbox?: string;
  color_checkbox_checkmark?: string;
  color_highlight?: string;
  color_link?: string;
  color_loader?: string;
  upsell_color?: string;
}

export interface Tag {
  name?: string;
}

export interface TaxesSettings {
  country_tax_settings?: Record<string, CountryTaxSettings>;
}

export interface TestVariant {
  /** IsTestVariant specifies that this site is a test variant used in a/b testing of configuration. */
  is_test_variant?: boolean;
  /** MasterSiteId specifies master of this test variant. */
  master_site_id?: string;
}

/**
 * Used when displaying delivery dates to the customer
 * @default "UNKNOWN_TIME_FORMATTING"
 */
export type TimeFormatting = "UNKNOWN_TIME_FORMATTING" | "MIN" | "MAX" | "INTERVAL";

export interface Timespan {
  /** Earliest delivery date in RFC3339 format. */
  from?: string;
  /** Latest delivery date in RFC3339 format. */
  to?: string;
}

export interface Tracking {
  /** The top-level container for all rules. */
  action_rules?: ActionsRules;
  carrier_product_mappings?: CarrierProductMapping[];
  carrier_product_settings?: CarrierProductSettings[];
  event_types?: EventTypes;
  notification_settings?: TrackingNotificationSettings;
  /**
   * Tracking page & portal custom branding settings served by service-moirai.
   * It's either all custom or default values. Leave it empty to use default values. [optional]
   */
  page_settings?: TrackingPageSettings;
  /** PickupReminderSettings configures settings for pickup reminder service. */
  pickup_reminder?: PickupReminderSettings;
  retention_policy?: TrackingRetentionPolicy;
  widget_settings?: TrackingWidgetSettings;
}

export interface TrackingActionsEmailAdditionalConfiguration {
  /**
   * Notification kind used to correctly map existing scenarios.
   * For new scenarios use TRACKING_RULES_NOTIFICATION_KIND
   */
  notification_kind?: NotificationKind;
}

export interface TrackingActionsEmailGlobalConfiguration {
  email_sender_name?: string;
  merchant_logo_url?: string;
  widget_url?: string;
}

export interface TrackingActionsEmarsysAdditionalConfiguration {
  contact_mode?: AdditionalConfigurationContactMode;
  /**
   * Notification kind used to correctly map existing scenarios.
   * For new scenarios use TRACKING_RULES_NOTIFICATION_KIND
   */
  notification_kind?: NotificationKind;
  trigger_name?: string;
}

export interface TrackingActionsEmarsysGlobalConfiguration {
  api_secret?: string;
  api_user?: string;
}

export interface TrackingActionsHttpAdditionalConfiguration {
  /** Header values that override or extend the global configuration. */
  headers_override?: Record<string, string>;
  /** Optional metadata to pass into template logic or logs. */
  metadata?: Record<string, string>;
  /** HTTP method to use when sending the request (defaults to POST if unspecified). */
  method?: HttpAdditionalConfigurationMethod;
  /** Controls how the system handles HTTP responses. */
  response_handling?: AdditionalConfigurationResponseHandling;
  /** Per-action request timeout. Overrides global timeout if set. */
  timeout?: string;
  /** The semantic name of this trigger, used by downstream consumers or template selection. */
  trigger_name?: string;
}

export interface TrackingActionsHttpGlobalConfiguration {
  /**
   * HTTP headers to be sent with the request.
   * Forbidden headers: "Content-Type", "Content-Length", "Accept-Encoding", "Host".
   */
  headers?: Record<string, string>;
  proxy?: HttpGlobalConfigurationProxy;
  /** Request timeout. */
  timeout?: string;
  url?: string;
}

export interface TrackingActionsNoopAdditionalConfiguration {
  additional?: object;
}

export interface TrackingActionsNoopGlobalConfiguration {
  global?: object;
}

/** @default "UNKNOWN" */
export type TrackingActionsType = "UNKNOWN" | "NOOP" | "HTTP" | "EMAIL" | "EMARSYS";

export interface TrackingNotificationChannel {
  enabled?: boolean;
  /**
   * Cel-go expressions to limit notifications.
   * When applied, notification will be sent only if predicates are met.
   *
   * bool custom_template = 4; //todo?
   */
  filters?: TrackingNotificationChannelFilter[];
  /**
   *  - SMS_CHANNEL: Ingrid internal SMS Channel.
   *  - EMAIL_CHANNEL: Ingrid internal email Channel.
   *  - CEP_CHANNEL: Customer Engagement Platform channel.
   *  - REVIEW_PLATFORM_CHANNEL: Review Platform channel.
   *  - INFOBIP_SMS_CHANNEL: Infobip provider SMS channel.
   *  - INFOBIP_EMAIL_CHANNEL: Infobip provider email channel.
   *  - API_NOTIFICATION_CHANNEL: API Notification channel.
   *  - KLAVIYO_CHANNEL: Klaviyo channel.
   *  - VOYADO_CHANNEL: Voyado channel.
   */
  type?: NotificationChannelType;
}

export interface TrackingNotificationChannelFilter {
  predicate?: string;
}

export interface TrackingNotificationChannelSettings {
  /** APINotification is a notification that sends a POST request to the specified URL. */
  api_notification?: TrackingNotificationChannelSettingsAPINotification;
  cep?: TrackingNotificationChannelSettingsCustomerEngagementPlatform;
  email?: TrackingNotificationChannelSettingsEmail;
  infobip?: TrackingNotificationChannelSettingsInfobip;
  klaviyo?: TrackingNotificationChannelSettingsKlaviyo;
  review_platform?: TrackingNotificationChannelSettingsReviewPlatform;
  sms?: TrackingNotificationChannelSettingsSms;
  voyado?: TrackingNotificationChannelSettingsVoyado;
}

/** APINotification is a notification that sends a POST request to the specified URL. */
export interface TrackingNotificationChannelSettingsAPINotification {
  enabled?: boolean;
  /**
   * HTTP headers to be sent with the request.
   * Forbidden headers: "Content-Type", "Content-Length", "Accept-Encoding", "Host".
   */
  headers?: Record<string, string>;
  /** HTTP Proxy settings. */
  proxy?: TrackingNotificationChannelSettingsAPINotificationProxy;
  url?: string;
}

/** HTTP Proxy settings. */
export interface TrackingNotificationChannelSettingsAPINotificationProxy {
  enabled?: boolean;
  /** InsecureSkipVerify controls whether a client verifies the server's certificate chain and host name. */
  insecure_skip_verify?: boolean;
  url?: string;
}

export interface TrackingNotificationChannelSettingsCustomerEngagementPlatform {
  api_secret?: string;
  api_user?: string;
  enabled?: boolean;
  /**
   *  - MODE_DEFAULT: With MODE_DEFAULT, we try to create basic contact by email address in the Emarsys system.
   * In case of conflict, we re-use already existing contact.
   *  - MODE_CUSTOM_CONTACT_CREATION: With MODE_CUSTOM_CONTACT, we try to create contact based on custom rules.
   * If more configuration is ever required, that would be separate settings.
   */
  mode?: CustomerEngagementPlatformMode;
}

export interface TrackingNotificationChannelSettingsEmail {
  enabled?: boolean;
  sender_address?: string;
  sender_logo_path?: string;
  sender_name?: string;
}

export interface TrackingNotificationChannelSettingsInfobip {
  api_key?: string;
  base_url?: string;
  email_options?: InfobipEmailOptions;
  /** deprecated */
  email_sender_address?: string;
  /** deprecated */
  email_sender_name?: string;
  enabled?: boolean;
  password?: string;
  sms_options?: InfobipSMSOptions;
  /** deprecated */
  sms_sender_name?: string;
  username?: string;
}

export interface TrackingNotificationChannelSettingsKlaviyo {
  api_key?: string;
  enabled?: boolean;
}

export interface TrackingNotificationChannelSettingsReviewPlatform {
  email_address?: string;
  enabled?: boolean;
}

export interface TrackingNotificationChannelSettingsSms {
  enabled?: boolean;
  sender_name?: string;
}

export interface TrackingNotificationChannelSettingsVoyado {
  api_key?: string;
  api_url?: string;
  enabled?: boolean;
  store_id?: string;
}

export interface TrackingNotificationSettings {
  channels?: TrackingNotificationChannelSettings;
  content?: TrackingNotificationSettingsContent;
  /** When defined, custom templates from that directory inside GCS will be used. */
  custom_templates_dir?: string;
  /** NotificationFeatures defines whether certain notification feature is enabled for a merchant. */
  features?: TrackingNotificationSettingsFeatures;
  notifications?: TrackingNotificationSettingsNotifications;
}

export interface TrackingNotificationSettingsContent {
  /**
   * Content configuration per channel.
   * TODO: remove in separate PRs. It was never used.
   */
  channels?: Record<string, ContentChannelConfig>;
  embedded_widget?: TrackingNotificationSettingsContentEmbeddedWidget;
  /** URL to the tracking widget on merchants page. If not defined - Ingrid tracking portal link will be used for notifications. [optional] */
  widget_url?: string;
}

export interface TrackingNotificationSettingsContentEmbeddedWidget {
  ingrid?: EmbeddedWidgetIngrid;
}

export interface TrackingNotificationSettingsFeatures {
  progress?: boolean;
  smart?: boolean;
}

export interface TrackingNotificationSettingsNotifications {
  progress?: TrackingProgressNotificationSettings;
  smart?: TrackingSmartNotificationSettings;
}

export interface TrackingPageSettings {
  /** Analytics provider configuration for the tracking page. */
  analytics?: AnalyticsSettings;
  /** configuration stores JSON for configuring widget and it's driven by FE. */
  configuration?: object;
  /** Enables the high contrast mode for the tracking page */
  enable_high_contrast?: BoolOptionV2;
  /** If set, the image logo becomes a clickable link leading to this URL. */
  page_logo_link_url?: string;
  /** GCS branding bucket relative path to the custom logo. */
  page_logo_path?: string;
  /**
   * The sections configuration. Supports either a const or expression values
   * SectionsConfig describes the sections that should be shown on the widget.
   */
  sections_config?: SectionsConfig;
  /** SectionsConfig describes the sections that should be shown on the widget. */
  sections_config_v2?: SectionsConfigV2;
  /** If set, overwrites the default value from the sender address. */
  sender_name?: StringOption;
  /** If set, overwrites the default value from the sender address. */
  sender_name_v2?: StringOptionV2;
  /** GCS branding bucket relative path the custom logo that will be shown on the tracking page's splashscreen. */
  splashscreen_logo_path?: string;
  /** GCS branding bucket relative path to the custom CSS used for Tracking Page styling. */
  stylesheet_path?: string;
  /**
   * Gradual rollout configuration for customer surveys.
   * Allows showing surveys to a controlled percentage of users to gather feedback
   * without affecting every visitor
   */
  survey?: FeatureRollout;
  /**
   * TranslationKey is a custom translation key for the delivery details section.
   * If not defined - default translation key will be used.
   */
  translation_key?: string;
  /**
   * Gradual rollout configuration for UI version changes.
   * Allows deploying new UI versions to a controlled percentage of visitors.
   */
  ui_version?: FeatureRollout;
  /** If set to true and sender name is not set the sender name will be taken from parcel instead of order. */
  use_sender_name_from_parcel?: BoolOption;
  /** If set to true and sender name is not set the sender name will be taken from parcel instead of order. */
  use_sender_name_from_parcel_v2?: BoolOptionV2;
}

export interface TrackingProgressNotificationSettings {
  steps?: TrackingProgressNotificationSettingsStepSettings[];
}

export interface TrackingProgressNotificationSettingsStepSettings {
  channels?: TrackingNotificationChannel[];
  step?: Step;
}

export interface TrackingRetentionPolicy {
  search?: TrackingRetentionPolicySearchRetentionPolicy;
  widget?: TrackingRetentionPolicyWidgetRetentionPolicy;
}

export interface TrackingRetentionPolicySearchRetentionPolicy {
  /**
   * DeleteAfterDays defines how long tracking search data should be kept.
   * This is measured from the moment when tracking order is created.
   * If not defined - default value of 90 days will be used.
   * @format int32
   */
  delete_after_days?: number;
}

export interface TrackingRetentionPolicyWidgetRetentionPolicy {
  /**
   * DeleteAfterDays defines how long tracking widget data should be kept.
   * This is measured from the moment when tracking order is created.
   * If not defined - default value of 90 days will be used.
   * Can't be larger than TrackingEventsRetentionPolicy.DeleteAfterDays.
   * @format int32
   */
  delete_after_days?: number;
}

export interface TrackingSmartNotificationSettings {
  /**
   * Centra order confirmed is sent when we receive `OrderConfirmed` exception from Centra.
   * It is applicable for merchatnts integrated via Centra.
   */
  centra_order_confirmed?: TrackingSmartNotificationSettingsCentraOrderConfirmed;
  delivery_delayed?: TrackingSmartNotificationSettingsDeliveryDelayed;
  delivery_failed?: TrackingSmartNotificationSettingsDeliveryFailed;
  order_cancelled_by_customer?: TrackingSmartNotificationSettingsOrderCancelledByCustomer;
  order_cancelled_by_merchant?: TrackingSmartNotificationSettingsOrderCancelledByMerchant;
  /**
   * Order items cancelled is a notifications that sends an update regarding items that were cancelled by merchant.
   * Order items cancelled can be sent using OrderItemsCancelled tracking exception.
   */
  order_items_cancelled?: TrackingSmartNotificationSettingsOrderItemsCancelled;
  /**
   * Order receipt is a notifications that sends order receipt as a attachment to the customer.
   * Order receipt can be sent using OrderReceiptAvailable tracking exception.
   */
  order_receipt?: TrackingSmartNotificationSettingsOrderReceipt;
  order_returned_in_store?: TrackingSmartNotificationSettingsOrderReturnedInStore;
  order_returned_to_warehouse?: TrackingSmartNotificationSettingsOrderReturnedToWarehouse;
  out_for_delivery?: TrackingSmartNotificationSettingsOutForDelivery;
  /** Customer did not pickup the parcel within the deadline. */
  parcel_not_collected?: TrackingSmartNotificationSettingsParcelNotCollected;
  /** Parcel refused by customer because its content is damaged. */
  parcel_refused_goods_damaged?: TrackingSmartNotificationSettingsParcelRefusedGoodsDamaged;
  /** Parcel refused by customer without specifying reason. */
  parcel_refused_no_reason?: TrackingSmartNotificationSettingsParcelRefusedNoReason;
  /** Parcel refused by customer because it was either ordered by mistake or is not needed anymore. */
  parcel_refused_not_wanted?: TrackingSmartNotificationSettingsParcelRefusedNotWanted;
  /** Parcel refused by customer because the packaging is damaged. */
  parcel_refused_packaging_damaged?: TrackingSmartNotificationSettingsParcelRefusedPackagingDamaged;
  /** PaymentDeclined is sent when we receive PaymentDeclined exception with reason EXPIRED. */
  payment_declined?: TrackingSmartNotificationSettingsPaymentDeclined;
  /** PaymentDeclinedFraudDeceted is sent when we receive PaymentDeclined with exception with reason FRAUD_CHECK. */
  payment_declined_fraud_detected?: TrackingSmartNotificationSettingsPaymentDeclinedFraudDetected;
  /**
   * Pickup reminder is a notification only for instore and pickup delivery type.
   * It is being sent after number of days defined by threshold pass before the parcel being picked up.
   */
  pickup_reminder?: TrackingSmartNotificationSettingsPickupReminder;
  pickup_reminder_V2?: TrackingSmartNotificationSettingsPickupReminderV2;
  /**
   * Price Adjustment Receipt is a notification that sends a price adjustment receipt to the customer as an attachment.
   * Price Adjustment Receipt can be sent using the PriceAdjustmentReceiptAvailable tracking exception.
   */
  price_adjustment_receipt?: TrackingSmartNotificationSettingsPriceAdjustmentReceipt;
  /** RemainingShipmentsCancelled is sent when we receive RemainingShipmentsCancelled exception. */
  remaining_shipments_cancelled?: TrackingSmartNotificationSettingsRemainingShipmentsCancelled;
  /**
   * Return receipt is a notification that sends a return receipt to the customer as an attachment.
   * Return receipt can be sent using the ReturnReceiptAvailable tracking exception.
   */
  return_receipt?: TrackingSmartNotificationSettingsReturnReceipt;
  submission_delayed?: TrackingSmartNotificationSettingsSubmissionDelayed;
}

/**
 * Centra order confirmed is sent when we receive `OrderConfirmed` exception from Centra.
 * It is applicable for merchatnts integrated via Centra.
 */
export interface TrackingSmartNotificationSettingsCentraOrderConfirmed {
  channels?: TrackingNotificationChannel[];
}

export interface TrackingSmartNotificationSettingsDeliveryDelayed {
  channels?: TrackingNotificationChannel[];
}

export interface TrackingSmartNotificationSettingsDeliveryFailed {
  channels?: TrackingNotificationChannel[];
}

export interface TrackingSmartNotificationSettingsOrderCancelledByCustomer {
  channels?: TrackingNotificationChannel[];
}

export interface TrackingSmartNotificationSettingsOrderCancelledByMerchant {
  channels?: TrackingNotificationChannel[];
}

/**
 * Order items cancelled is a notifications that sends an update regarding items that were cancelled by merchant.
 * Order items cancelled can be sent using OrderItemsCancelled tracking exception.
 */
export interface TrackingSmartNotificationSettingsOrderItemsCancelled {
  channels?: TrackingNotificationChannel[];
}

/**
 * Order receipt is a notifications that sends order receipt as a attachment to the customer.
 * Order receipt can be sent using OrderReceiptAvailable tracking exception.
 */
export interface TrackingSmartNotificationSettingsOrderReceipt {
  channels?: TrackingNotificationChannel[];
}

export interface TrackingSmartNotificationSettingsOrderReturnedInStore {
  channels?: TrackingNotificationChannel[];
}

export interface TrackingSmartNotificationSettingsOrderReturnedToWarehouse {
  channels?: TrackingNotificationChannel[];
}

export interface TrackingSmartNotificationSettingsOutForDelivery {
  channels?: TrackingNotificationChannel[];
}

/** Customer did not pickup the parcel within the deadline. */
export interface TrackingSmartNotificationSettingsParcelNotCollected {
  channels?: TrackingNotificationChannel[];
}

/** Parcel refused by customer because its content is damaged. */
export interface TrackingSmartNotificationSettingsParcelRefusedGoodsDamaged {
  channels?: TrackingNotificationChannel[];
}

/** Parcel refused by customer without specifying reason. */
export interface TrackingSmartNotificationSettingsParcelRefusedNoReason {
  channels?: TrackingNotificationChannel[];
}

/** Parcel refused by customer because it was either ordered by mistake or is not needed anymore. */
export interface TrackingSmartNotificationSettingsParcelRefusedNotWanted {
  channels?: TrackingNotificationChannel[];
}

/** Parcel refused by customer because the packaging is damaged. */
export interface TrackingSmartNotificationSettingsParcelRefusedPackagingDamaged {
  channels?: TrackingNotificationChannel[];
}

/** PaymentDeclined is sent when we receive PaymentDeclined exception with reason EXPIRED. */
export interface TrackingSmartNotificationSettingsPaymentDeclined {
  channels?: TrackingNotificationChannel[];
}

/** PaymentDeclinedFraudDeceted is sent when we receive PaymentDeclined with exception with reason FRAUD_CHECK. */
export interface TrackingSmartNotificationSettingsPaymentDeclinedFraudDetected {
  channels?: TrackingNotificationChannel[];
}

/**
 * Pickup reminder is a notification only for instore and pickup delivery type.
 * It is being sent after number of days defined by threshold pass before the parcel being picked up.
 */
export interface TrackingSmartNotificationSettingsPickupReminder {
  channels?: TrackingNotificationChannel[];
  /**
   * Number of hours that need to pass from pickup for the reminder to be sent.
   * @format int32
   */
  threshold?: number;
}

export interface TrackingSmartNotificationSettingsPickupReminderV2 {
  channels?: TrackingNotificationChannel[];
}

/**
 * Price Adjustment Receipt is a notification that sends a price adjustment receipt to the customer as an attachment.
 * Price Adjustment Receipt can be sent using the PriceAdjustmentReceiptAvailable tracking exception.
 */
export interface TrackingSmartNotificationSettingsPriceAdjustmentReceipt {
  channels?: TrackingNotificationChannel[];
}

/** RemainingShipmentsCancelled is sent when we receive RemainingShipmentsCancelled exception. */
export interface TrackingSmartNotificationSettingsRemainingShipmentsCancelled {
  channels?: TrackingNotificationChannel[];
}

/**
 * Return receipt is a notification that sends a return receipt to the customer as an attachment.
 * Return receipt can be sent using the ReturnReceiptAvailable tracking exception.
 */
export interface TrackingSmartNotificationSettingsReturnReceipt {
  channels?: TrackingNotificationChannel[];
}

export interface TrackingSmartNotificationSettingsSubmissionDelayed {
  channels?: TrackingNotificationChannel[];
}

export interface TrackingWidgetSettings {
  /** Analytics provider configuration for the tracking widget. */
  analytics?: AnalyticsSettings;
  /** configuration stores JSON for configuring the widget and is driven by FE. */
  configuration?: object;
  /**
   * CustomURLTemplate is the URL to the tracking widget placed on merchant page
   * If not defined - Ingrid tracking portal URL will be used for widget.
   * There are following placeholders available:
   * - <token> - tracking token
   * - <identifier> - tracking identifier (tracking number or order number)
   * - <contact> - customer email
   * - <locale> - locale
   * Example: https://www.example.com/tracking?token=<token>
   *          https://www.example.com/tracking?identifier=<identifier>&contact=<contact>
   */
  custom_url_template?: string;
  /** Enables the high contrast mode for the tracking widget */
  enable_high_contrast?: BoolOptionV2;
  /**
   * The sections configuration. Supports either a const or expression values
   * SectionsConfig describes the sections that should be shown on the widget.
   */
  sections_config?: SectionsConfig;
  /**
   * The sections configuration. Supports either a const or expression values
   * SectionsConfig describes the sections that should be shown on the widget.
   */
  sections_config_v2?: SectionsConfigV2;
  /** If set, overwrites the default value from the sender address. */
  sender_name?: StringOption;
  /** If set, overwrites the default value from the sender address. */
  sender_name_v2?: StringOptionV2;
  /** GCS branding bucket relative path to the custom CSS used for Tracking Widget styling. */
  stylesheet_path?: string;
  /**
   * Gradual rollout configuration for customer surveys.
   * Allows showing surveys to a controlled percentage of users to gather feedback
   * without affecting every visitor
   */
  survey?: FeatureRollout;
  /**
   * TranslationKey is a custom translation key for the delivery details section.
   * If not defined - default translation key will be used.
   */
  translation_key?: string;
  /**
   * Gradual rollout configuration for UI version changes.
   * Allows deploying new UI versions to a controlled percentage of visitors.
   */
  ui_version?: FeatureRollout;
  /** If set to true and sender name is not set the sender name will be taken from parcel instead of order. */
  use_sender_name_from_parcel?: BoolOption;
  /** If set to true and sender name is not set the sender name will be taken from parcel instead of order. */
  use_sender_name_from_parcel_v2?: BoolOptionV2;
}

/**
 *  - TYPE_CARRIER_DEFAULT: Default addons returned in FetchShippingOptions under default_addons field.
 * Default addons are not presented to end customer in UI (all other delivery addons are presented).
 *  - TYPE_ID_CHECK: Basic identity check – courier verifies recipient’s ID at delivery.
 *  - TYPE_WITHOUT_ID_CHECK: Basic identity check – courier will not verify recipient’s ID at delivery.
 *  - TYPE_DIGITAL_CHECK: Digital identity verification using BankID or similar.
 *  - TYPE_ID_MATCH_RECIPIENT: ID must match the name of the recipient (e.g. delivery only to person on label).
 *  - TYPE_AGE_CHECK: Basic age verification – courier confirms recipient meets age requirement (typically 18+).
 *  - TYPE_EXTENDED_AGE_CHECK: Extended age verification – includes more than one: signature, ID check or digital validation.
 *  - TYPE_AGE_CHECK_16: Age check requiring the recipient to be at least 16 years old.
 *  - TYPE_EXTENDED_AGE_CHECK_16: Extended age check for 16+ –  includes more than one: signature, ID check or digital validation.
 *  - TYPE_AGE_CHECK_18: Age check requiring the recipient to be at least 18 years old.
 *  - TYPE_EXTENDED_AGE_CHECK_18: Extended age check for 18+ – includes more than one: signature, ID check or digital validation.
 *  - TYPE_AGE_CHECK_20: Age check requiring the recipient to be at least 20 years old.
 *  - TYPE_AGE_CHECK_21: Age check requiring the recipient to be at least 21 years old.
 *  - TYPE_EMAIL: Notify recipient via email when shipment status is updated.
 *  - TYPE_SMS: Notify recipient via SMS when shipment status is updated.
 *  - TYPE_LETTER: Notify recipient via physical letter (paper notice, e.g., undeliverable or missed delivery).
 *  - TYPE_CALL: Notify recipient via phone call (automated or manual).
 *  - TYPE_NOTIFICATION: General or fallback notification without specifying the communication channel.
 *  - TYPE_PRE_EMAIL: Notify recipient via email before the shipment is dispatched or delivered (pre-alert).
 *  - TYPE_PRE_SMS: Notify recipient via SMS before the shipment is dispatched or delivered (pre-alert).
 *  - TYPE_PRE_CALL: Notify recipient via phone call before the shipment is dispatched or delivered.
 *  - TYPE_PRE_NOTIFICATION: General pre-notification without specifying channel (can be email, SMS, or call).
 *  - TYPE_WITHOUT_PRE_NOTIFICATION: Shipment proceeds without any pre-notification.
 *  - TYPE_LEAVE_AT_DOOR: Leave the parcel at the recipient’s door or in a designated safe place without requiring interaction.
 *  - TYPE_CARRY_IN: Courier is required to carry the parcel inside the recipient's home or building.
 *  - TYPE_CARRY_OUT: Courier is required to carry the parcel outside the recipient's home or building.
 *  - TYPE_HOME_DELIVERY: Deliver the parcel directly to the recipient’s home address instead of a pickup location or access point.
 *  - TYPE_ENDORSEMENT_ABANDON: Abandon the shipment if it cannot be delivered (no return or retry attempt).
 *  - TYPE_PERSONAL_DELIVERY: Deliver the parcel directly into the hands of the recipient; no drop-off allowed.
 *  - TYPE_INSTALLATION: Perform installation of the delivered item at the recipient's location (e.g., appliances or furniture).
 *  - TYPE_REMOVAL: Remove old items (e.g., used furniture or appliances) from the recipient’s location as part of the delivery service.
 *  - TYPE_RECYCLE: Collect old or used items from the recipient for recycling during the delivery process.
 *  - TYPE_SWAP: Collect old or used items from the recipient during the delivery process and swap with the delivery.
 *  - TYPE_DISABLE_MODIFICATIONS: Prevents the recipient from modifying delivery options, such as changing delivery location, time, or leave-at-door settings.
 *  - TYPE_OPTIONAL_SERVICE_POINT: Allows the recipient to change the pickup location or service point before delivery.
 *  - TYPE_FLEX_CHANGE: Allows the recipient to flexibly change the delivery method, time, or location while the shipment is in transit.
 *  - TYPE_UNWRAPPING: Perform unwrapping on delivered item at recipient's location.
 *  - TYPE_PICKUP_POINT_DELIVERY: Deliver the parcel directly to the pickup location or access point.
 *  - TYPE_MAILBOX_DELIVERY: Deliver the parcel directly to the mailbox directly.
 *  - TYPE_DELIVERY_BEFORE_8: Deliver the parcel before 8:00 AM on the scheduled delivery day.
 *  - TYPE_DELIVERY_BEFORE_9: Deliver the parcel before 9:00 AM on the scheduled delivery day.
 *  - TYPE_DELIVERY_BEFORE_10: Deliver the parcel before 10:00 AM on the scheduled delivery day.
 *  - TYPE_DELIVERY_BEFORE_12: Deliver the parcel before 12:00 PM (noon) on the scheduled delivery day.
 *  - TYPE_EVENING_DELIVERY: Deliver the parcel during the evening hours, typically after 5:00 PM.
 *  - TYPE_EXPRESS_DELIVERY: Prioritize the shipment for the fastest possible delivery, typically within 1–2 days depending on the carrier.
 *  - TYPE_PRIORITY_DELIVERY: Prioritize internal processing of the shipment to improve transit performance (carrier-defined).
 *  - TYPE_SATURDAY_DELIVERY: Deliver the parcel on a Saturday, even if it is outside standard weekday schedules.
 *  - TYPE_SUNDAY_DELIVERY: Deliver the parcel on a Sunday, if available within the carrier’s service area.
 *  - TYPE_SAME_DAY_DELIVERY: Deliver the parcel on the same day it is shipped, usually within a few hours.
 *  - TYPE_TIME_AGREED_DELIVERY: Delivery at a specific time window agreed between the sender and the carrier.
 *  - TYPE_BY_TRUCK: Shipment must be delivered using a truck, typically due to size, weight, or palletized load.
 *  - TYPE_PALLET_TRANSFER: EUR-pallet must be exchanged at the time of delivery.
 *  - TYPE_FRANKED_POSTAGE: Pre-paid postage method where the sender uses a franking machine or online portal to apply postage instead of stamps.
 *  - TYPE_CONTAINER_RENT: Temporary rental of a container or shipping unit required for the transport. Typically used for pallet shipments.
 *  - TYPE_LOADING_ASSISTANCE: Shipment requires mechanical or manual assistance to be loaded onto the vehicle at the pickup location.
 *  - TYPE_UNLOADING_ASSISTANCE: Shipment requires mechanical or manual assistance to be unloaded from the vehicle at the delivery location.
 *  - TYPE_THERMO_COLD: Shipment requires cold temperature handling (e.g., 2–8°C).
 *  - TYPE_THERMO_FROZEN: Shipment must be kept frozen throughout transport. (e.g., below 0°C)
 *  - TYPE_THERMO_WARM: Shipment must be kept warm or above a certain minimum temperature (e.g., 8–25°C).
 *  - TYPE_LONG_GOODS: Item is long or oversized, requiring special handling or space.
 *  - TYPE_PHARMACEUTICALS: Shipment contains pharmaceuticals and may require regulated handling.
 *  - TYPE_DANGEROUS_GOODS: Shipment contains hazardous materials and must comply with safety regulations.
 *  - TYPE_DANGEROUS_GOODS_LQ: Shipment contains a limited quantity of dangerous goods, exempt from full ADR handling.
 *  - TYPE_NON_STACKABLE: Parcel cannot be stacked during transport.
 *  - TYPE_POSTABLE: Parcel can fit directly into a mailbox.
 *  - TYPE_HANGING_GARMENT: Shipment contains garments that must remain hanging during transit.
 *  - TYPE_FRAGILE: Parcel is fragile and must be handled with extra care.
 *  - TYPE_ALCOHOL: Shipment contains alcohol and may require age verification or special handling.
 *  - TYPE_TYRES: Shipment contains tires, often bulky and requiring dedicated space or securing.
 *  - TYPE_NICOTINE: Shipment contains nicotine products and may require legal handling procedures.
 *  - TYPE_HEAVY: Indicates that the shipment is heavy and may require special handling or lifting equipment.
 *  - TYPE_COD: The recipient pays for the goods or shipping upon delivery (cash, card, or local method).
 *  - TYPE_SHIPPING_DISCOUNT: Applies a negotiated discount or subsidy to the shipping cost (usually requires prior agreement).
 *  - TYPE_RECIPIENT_PAYS: The recipient is responsible for covering the shipping cost, typically via invoice or contract with the carrier.
 *  - TYPE_KIND_QUANTITY: Specifies the type and quantity of items in the shipment (e.g., 3 boxes, 2 bottles); often required for customs or tariff purposes.
 *  - TYPE_CREDIT_WITH_INVOICE_DOCUMENTATION: Enables shipment to be billed after delivery via invoice, with official invoice documentation provided.
 *  - TYPE_CREDIT_WITHOUT_INVOICE_DOCUMENTATION: Enables post-delivery billing on credit without requiring formal invoice documentation.
 *  - TYPE_INSURANCE: Provides coverage for loss or damage of the shipment, based on declared value or carrier-specific terms.
 *  - TYPE_TERMINAL_PICKUP: The shipment will not be delivered to the recipient's address but must be picked up from a designated terminal or depot.
 *  - TYPE_PERSONAL_PICKUP: Shipment must be collected in person by the recipient, typically with ID verification, from a post office, store, or pickup point.
 *  - TYPE_RETENTION_EXTENDED: Extends the retention period for the shipment at the pickup location, typically from 7 to 14 days.
 *  - TYPE_RETURN_TO_SENDER: Instructs the carrier to return the shipment to the sender if it cannot be delivered to the recipient.
 *  - TYPE_RETURN_QR_CODE: Allows the recipient to return the shipment using a scannable QR code instead of / along with printed return label.
 *  - TYPE_PRINT_RETURN_LABEL: Enables printing of the return label at a pickup location or drop-off point, instead of requiring the sender to print it in advance.
 *  - TYPE_CLIMATE_COMPENSATION: Offsets the carbon emissions of the shipment by contributing to certified environmental initiatives.
 *  - TYPE_SHIPMENT_CONSOLIDATION: Indicates that multiple shipments are merged into one consolidated delivery, typically for logistical or operational efficiency.
 *  - TYPE_SHIPMENT_MULTI_PARCELS: Indicates that the shipment consists of multiple parcels under a single tracking number or delivery order.
 *  - TYPE_HIDE_CUSTOMER_PHONE: Hides the recipient's phone number from the carrier label or transmission for privacy or regulatory reasons.
 *  - TYPE_HIDE_CUSTOMER_EMAIL: Hides the recipient's email address from the carrier label or transmission for privacy or regulatory reasons.
 *  - TYPE_CUSTOMER_NAME_AS_CARRIER_INSTRUCTIONS: Passes the customer's name as part of delivery instructions, often used to override carrier restrictions or labels.
 *  - TYPE_RESIDENTIAL_ADDRESS_INDICATOR: Marks the delivery address as a residential location, which may affect handling or surcharges.
 *  - TYPE_SPLIT_SHIPMENT: Splits the shipment into multiple parcels or deliveries, typically due to size, weight, or inventory constraints.
 *  - TYPE_HIDE_CUSTOMER_DETAILS: Hides the customer details from the carrier label or transmission for privacy or regulatory reasons.
 *  - TYPE_SIGNATURE: Requires the recipient (or someone at the address) to sign for the shipment upon delivery.
 *  - TYPE_ADULT_SIGNATURE: Requires a legally recognized adult to sign for the shipment, often used for age-restricted deliveries.
 *  - TYPE_INDIRECT_SIGNATURE: Allows someone other than the primary recipient (e.g., neighbor or receptionist) to sign for the shipment.
 *  - TYPE_WITHOUT_POD: The carrier will deliver the package without collecting a signature or proof of delivery.
 *  - TYPE_SIGNATURE_PHOTO_POD: Captures a photo as proof of delivery, often showing the parcel at the drop-off location.
 *  - TYPE_EXTENDED_SIGNATURE_POD: Includes multiple proof of deliveries, such as a high-resolution image, signature, timestamp, and geolocation.
 * @default "TYPE_UNKNOWN"
 */
export type Type =
  | "TYPE_UNKNOWN"
  | "TYPE_CUSTOM"
  | "TYPE_RETURN"
  | "TYPE_CARRIER"
  | "TYPE_CARRIER_DEFAULT"
  | "TYPE_ID_CHECK"
  | "TYPE_WITHOUT_ID_CHECK"
  | "TYPE_DIGITAL_CHECK"
  | "TYPE_ID_MATCH_RECIPIENT"
  | "TYPE_AGE_CHECK"
  | "TYPE_EXTENDED_AGE_CHECK"
  | "TYPE_AGE_CHECK_16"
  | "TYPE_EXTENDED_AGE_CHECK_16"
  | "TYPE_AGE_CHECK_18"
  | "TYPE_EXTENDED_AGE_CHECK_18"
  | "TYPE_AGE_CHECK_20"
  | "TYPE_AGE_CHECK_21"
  | "TYPE_EMAIL"
  | "TYPE_SMS"
  | "TYPE_LETTER"
  | "TYPE_CALL"
  | "TYPE_NOTIFICATION"
  | "TYPE_PRE_EMAIL"
  | "TYPE_PRE_SMS"
  | "TYPE_PRE_CALL"
  | "TYPE_PRE_NOTIFICATION"
  | "TYPE_WITHOUT_PRE_NOTIFICATION"
  | "TYPE_LEAVE_AT_DOOR"
  | "TYPE_CARRY_IN"
  | "TYPE_CARRY_OUT"
  | "TYPE_HOME_DELIVERY"
  | "TYPE_ENDORSEMENT_ABANDON"
  | "TYPE_PERSONAL_DELIVERY"
  | "TYPE_INSTALLATION"
  | "TYPE_REMOVAL"
  | "TYPE_RECYCLE"
  | "TYPE_SWAP"
  | "TYPE_DISABLE_MODIFICATIONS"
  | "TYPE_OPTIONAL_SERVICE_POINT"
  | "TYPE_FLEX_CHANGE"
  | "TYPE_UNWRAPPING"
  | "TYPE_PICKUP_POINT_DELIVERY"
  | "TYPE_MAILBOX_DELIVERY"
  | "TYPE_DELIVERY_BEFORE_8"
  | "TYPE_DELIVERY_BEFORE_9"
  | "TYPE_DELIVERY_BEFORE_10"
  | "TYPE_DELIVERY_BEFORE_12"
  | "TYPE_EVENING_DELIVERY"
  | "TYPE_EXPRESS_DELIVERY"
  | "TYPE_PRIORITY_DELIVERY"
  | "TYPE_SATURDAY_DELIVERY"
  | "TYPE_SUNDAY_DELIVERY"
  | "TYPE_SAME_DAY_DELIVERY"
  | "TYPE_TIME_AGREED_DELIVERY"
  | "TYPE_BY_TRUCK"
  | "TYPE_PALLET_TRANSFER"
  | "TYPE_FRANKED_POSTAGE"
  | "TYPE_CONTAINER_RENT"
  | "TYPE_LOADING_ASSISTANCE"
  | "TYPE_UNLOADING_ASSISTANCE"
  | "TYPE_THERMO_COLD"
  | "TYPE_THERMO_FROZEN"
  | "TYPE_THERMO_WARM"
  | "TYPE_LONG_GOODS"
  | "TYPE_PHARMACEUTICALS"
  | "TYPE_DANGEROUS_GOODS"
  | "TYPE_DANGEROUS_GOODS_LQ"
  | "TYPE_NON_STACKABLE"
  | "TYPE_POSTABLE"
  | "TYPE_HANGING_GARMENT"
  | "TYPE_FRAGILE"
  | "TYPE_ALCOHOL"
  | "TYPE_TYRES"
  | "TYPE_NICOTINE"
  | "TYPE_HEAVY"
  | "TYPE_COD"
  | "TYPE_SHIPPING_DISCOUNT"
  | "TYPE_RECIPIENT_PAYS"
  | "TYPE_KIND_QUANTITY"
  | "TYPE_CREDIT_WITH_INVOICE_DOCUMENTATION"
  | "TYPE_CREDIT_WITHOUT_INVOICE_DOCUMENTATION"
  | "TYPE_INSURANCE"
  | "TYPE_TERMINAL_PICKUP"
  | "TYPE_PERSONAL_PICKUP"
  | "TYPE_RETENTION_EXTENDED"
  | "TYPE_RETURN_TO_SENDER"
  | "TYPE_RETURN_QR_CODE"
  | "TYPE_PRINT_RETURN_LABEL"
  | "TYPE_CLIMATE_COMPENSATION"
  | "TYPE_SHIPMENT_CONSOLIDATION"
  | "TYPE_SHIPMENT_MULTI_PARCELS"
  | "TYPE_HIDE_CUSTOMER_PHONE"
  | "TYPE_HIDE_CUSTOMER_EMAIL"
  | "TYPE_CUSTOMER_NAME_AS_CARRIER_INSTRUCTIONS"
  | "TYPE_RESIDENTIAL_ADDRESS_INDICATOR"
  | "TYPE_SPLIT_SHIPMENT"
  | "TYPE_HIDE_CUSTOMER_DETAILS"
  | "TYPE_SIGNATURE"
  | "TYPE_ADULT_SIGNATURE"
  | "TYPE_INDIRECT_SIGNATURE"
  | "TYPE_WITHOUT_POD"
  | "TYPE_SIGNATURE_PHOTO_POD"
  | "TYPE_EXTENDED_SIGNATURE_POD";

export interface UpdateCustomBookingMethodsRequest {
  custom_booking_methods?: CustomBookingMethod[];
  site_id?: string;
  update_details?: UpdateDetails;
}

export interface UpdateCustomBookingMethodsResponse {
  custom_booking_methods?: CustomBookingMethod[];
}

export interface UpdateDetails {
  /**
   * [Optional] If update source is DRAFT_MERGE draft_site_id contains site_id of the draft that is merged
   * to the master site.
   */
  draft_site_id?: string;
  source?: UpdateSource;
  user_id?: string;
}

export interface UpdateSiteRequest {
  site?: Site;
  update_details?: UpdateDetails;
}

export interface UpdateSiteResponse {
  site?: Site;
}

/** @default "UNKNOWN_SOURCE" */
export type UpdateSource =
  | "UNKNOWN_SOURCE"
  | "DRAFT_MERGE"
  | "RULER_NG"
  | "INTERNAL"
  | "SELFCARE"
  | "BOOKING_RULES_CONFIG";

export interface ValidateMerchantRequest {
  merchant?: Merchant;
}

export interface ValidateSiteRequest {
  site?: Site;
}

export interface ValidateSiteResponse {
  errors?: string[];
  warnings?: string[];
}

export interface VirtualMethod {
  /** LegacyShippingMethod allows backwards compatibility with current VirtualMethod solution. */
  legacy_shipping_method?: string;
  methods?: Method[];
}

export interface Warehouse {
  /** Common address entity that used almost everywhere in Ingrid's API. */
  address?: Address;
  contact_data?: ContactData;
  created_at?: string;
  external_id?: string;
  id?: string;
  operating_schedule?: Record<string, OperatingScheduleItem>;
  shipping_date_adjustment?: ShippingDateAdjustment;
  state?: State;
  /** Status is derived from state, with unknown state being considered as active. */
  status?: Status;
  timezone?: string;
}

export interface WidgetConfiguration {
  by_country?: Record<string, WidgetCountryConfiguration>;
  custom_stylesheet_path?: string;
  features?: Features;
  release_label?: string;
  shipping_option_configuration?: Record<string, ShippingOptionConfiguration>;
  style?: Style;
  /** Deprecated, use by_country.upfront_carriers instead. [deprecated] */
  upfront_carriers?: Record<string, MethodList>;
}

export interface WidgetCountryConfiguration {
  carrier_logos?: MethodList;
  features?: Features;
  upfront_carriers?: MethodList;
}

export interface Error {
  /** @format int32 */
  code?: number;
  details?: Any[];
  message?: string;
}

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "/v1/config" });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Config API
 * @version 1.0
 * @baseUrl /v1/config
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  carrieraddonsGet = {
    /**
     * No description
     *
     * @name ConfigGetCarrierAddons
     * @summary GetCarrierAddons returns a list of addons with their full details.
     * @request GET:/carrieraddons.get
     * @secure
     */
    configGetCarrierAddons: (params: RequestParams = {}) =>
      this.request<GetCarrierAddonsResponse, Error>({
        path: `/carrieraddons.get`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  customBookingMethodsUpdate = {
    /**
     * No description
     *
     * @name ConfigUpdateCustomBookingMethods
     * @request POST:/custom_booking_methods.update
     * @secure
     */
    configUpdateCustomBookingMethods: (body: UpdateCustomBookingMethodsRequest, params: RequestParams = {}) =>
      this.request<UpdateCustomBookingMethodsResponse, Error>({
        path: `/custom_booking_methods.update`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  merchantCreate = {
    /**
     * No description
     *
     * @name ConfigCreateMerchant
     * @summary CreateMerchant as specified in the request. Generate private keys for the created sites.
     * @request POST:/merchant.create
     * @secure
     */
    configCreateMerchant: (body: CreateMerchantRequest, params: RequestParams = {}) =>
      this.request<CreateMerchantResponse, Error>({
        path: `/merchant.create`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  merchantDelete = {
    /**
     * No description
     *
     * @name ConfigDeleteMerchant
     * @summary DeleteMerchant as specified in query. This method deletes sites as well.
     * @request DELETE:/merchant.delete
     * @secure
     */
    configDeleteMerchant: (
      query?: {
        merchant_id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<RenameMerchantResponse, Error>({
        path: `/merchant.delete`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  merchantGet = {
    /**
     * No description
     *
     * @name ConfigGetMerchant
     * @request GET:/merchant.get
     * @secure
     */
    configGetMerchant: (
      query?: {
        merchant_id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetMerchantResponse, Error>({
        path: `/merchant.get`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  merchantRename = {
    /**
     * No description
     *
     * @name ConfigRenameMerchant
     * @summary RenameSite allows to rename current merchant.
     * @request POST:/merchant.rename
     * @secure
     */
    configRenameMerchant: (body: RenameMerchantRequest, params: RequestParams = {}) =>
      this.request<RenameMerchantResponse, Error>({
        path: `/merchant.rename`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  merchantValidate = {
    /**
     * No description
     *
     * @name ConfigValidateMerchant
     * @summary ValidateMerchant as specified in request.
     * @request POST:/merchant.validate
     * @secure
     */
    configValidateMerchant: (body: ValidateMerchantRequest, params: RequestParams = {}) =>
      this.request<RenameMerchantResponse, Error>({
        path: `/merchant.validate`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  merchantsList = {
    /**
     * No description
     *
     * @name ConfigListMerchants
     * @request GET:/merchants.list
     * @secure
     */
    configListMerchants: (
      query?: {
        "site_filtering.standard"?: boolean;
        "site_filtering.drafts"?: boolean;
        "site_filtering.test_variants"?: boolean;
        "site_filtering.volatiles"?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ListMerchantsResponse, Error>({
        path: `/merchants.list`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  privatekeyGenerate = {
    /**
     * No description
     *
     * @name ConfigGenerateNewPrivateKeyForSite
     * @request POST:/privatekey.generate
     * @secure
     */
    configGenerateNewPrivateKeyForSite: (body: GenerateNewPrivateKeyForSiteRequest, params: RequestParams = {}) =>
      this.request<GenerateNewPrivateKeyForSiteResponse, Error>({
        path: `/privatekey.generate`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  privatekeyGet = {
    /**
     * No description
     *
     * @name ConfigGetPrivateKey
     * @request GET:/privatekey.get
     * @secure
     */
    configGetPrivateKey: (
      query?: {
        site_id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetPrivateKeyResponse, Error>({
        path: `/privatekey.get`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  privatekeyMove = {
    /**
     * No description
     *
     * @name ConfigMovePrivateKey
     * @request POST:/privatekey.move
     * @secure
     */
    configMovePrivateKey: (body: MovePrivateKeyRequest, params: RequestParams = {}) =>
      this.request<RenameMerchantResponse, Error>({
        path: `/privatekey.move`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  shippingmethodsGet = {
    /**
     * No description
     *
     * @name ConfigGetShippingMethods
     * @summary GetShippingMethods returns a list of all shipping methods available in the system.
     * @request GET:/shippingmethods.get
     * @secure
     */
    configGetShippingMethods: (
      query?: {
        site_id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetShippingMethodsResponse, Error>({
        path: `/shippingmethods.get`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  siteCreate = {
    /**
     * No description
     *
     * @name ConfigCreateSite
     * @summary CreateSite as specified in request. Generate private key for this site.
     * @request POST:/site.create
     * @secure
     */
    configCreateSite: (body: CreateSiteRequest, params: RequestParams = {}) =>
      this.request<CreateSiteResponse, Error>({
        path: `/site.create`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  siteDelete = {
    /**
     * No description
     *
     * @name ConfigDeleteSite
     * @summary DeleteSite as specified in query.
     * @request DELETE:/site.delete
     * @secure
     */
    configDeleteSite: (
      query?: {
        site_id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<RenameMerchantResponse, Error>({
        path: `/site.delete`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  siteGet = {
    /**
     * No description
     *
     * @name ConfigGetSite
     * @request GET:/site.get
     * @secure
     */
    configGetSite: (
      query?: {
        site_id?: string;
        /**
         *  - ALL_CONFIG: ACTIVE and INACTIVE
         * @default "ALL_CONFIG"
         */
        config_type?: "ALL_CONFIG" | "ONLY_ACTIVE";
        /**
         * SiteVersion to fetch. This is an optional argument: when not specified, the newest version is returned.
         * When invalid site version is provided, the result is unspecified.
         */
        site_version?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetSiteResponse, Error>({
        path: `/site.get`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  siteRename = {
    /**
     * No description
     *
     * @name ConfigRenameSite
     * @summary RenameSite allows to rename current site.
     * @request POST:/site.rename
     * @secure
     */
    configRenameSite: (body: RenameSiteRequest, params: RequestParams = {}) =>
      this.request<RenameSiteResponse, Error>({
        path: `/site.rename`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  siteUpdate = {
    /**
     * No description
     *
     * @name ConfigUpdateSite
     * @summary UpdateSite as specified in the request. This method leaves private key untouched.
     * @request POST:/site.update
     * @secure
     */
    configUpdateSite: (body: UpdateSiteRequest, params: RequestParams = {}) =>
      this.request<UpdateSiteResponse, Error>({
        path: `/site.update`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  siteValidate = {
    /**
     * No description
     *
     * @name ConfigValidateSite
     * @summary ValidateSite as specified in request.
     * @request POST:/site.validate
     * @secure
     */
    configValidateSite: (body: ValidateSiteRequest, params: RequestParams = {}) =>
      this.request<ValidateSiteResponse, Error>({
        path: `/site.validate`,
        method: "POST",
        body: body,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  sitesDelete = {
    /**
     * No description
     *
     * @name ConfigDeleteSites
     * @summary DeleteSites as specified in query.
     * @request DELETE:/sites.delete
     * @secure
     */
    configDeleteSites: (
      query?: {
        site_ids?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<RenameMerchantResponse, Error>({
        path: `/sites.delete`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
